
       
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Alert,
  alpha,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  LinearProgress,
  MenuItem,
  Snackbar,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import GroupsIcon from "@mui/icons-material/Groups";
import PaymentIcon from "@mui/icons-material/Payment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import SchoolIcon from "@mui/icons-material/School";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

import Inventory2Icon from "@mui/icons-material/Inventory2";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";


const API_BASE =
  process.env.REACT_APP_API_BASE || "https://panel.haymestasarim.com/api";

const BRAND = {
  orange: "#f97316",
  orangeDark: "#c2410c",
  blue: "#2563eb",
  blueDark: "#0f172a",
  softBlue: "#eff6ff",
  softOrange: "#fff7ed",
  green: "#16a34a",
  red: "#dc2626",
  purple: "#7c3aed",
};

const TEXT = {
  tr: {
    pageTitle: "Canlı Masa Yönetimi",
    pageSubtitle:
      "Salonları, masaları, gelen kişileri, adisyonları, ödeme taleplerini ve masa performansını tek ekrandan yönetin.",
    refresh: "Yenile",
    addSalon: "Salon Ekle",
    editSalon: "Salon Düzenle",
    addTable: "Masa Ekle",
    editTable: "Masa Düzenle",
    allSalons: "Tüm Salonlar",
    search: "Masa, salon, kişi veya not ara",
    totalTables: "Toplam Masa",
    activeTables: "Aktif Masa",
    paymentWaiting: "Ödeme Bekleyen",
    emptyTables: "Boş Masa",
    totalRemaining: "Kalan Hesap",
    totalRevenue: "Toplam Ciro",
    totalPaid: "Ödenen",
    guests: "Kişiler",
    table: "Masa",
    salon: "Salon",
    status: "Durum",
    total: "Toplam",
    paid: "Ödenen",
    remaining: "Kalan",
    orders: "Siparişler",
    paymentRequests: "Ödeme Talepleri",
    openBill: "Adisyon Aç",
    addGuest: "Kişi Ekle",
    editGuest: "Kişi Düzenle",
    clearTable: "Masayı Boşalt",
    copyQr: "QR Linkini Kopyala",
    cashPanel: "Kasaya Git",
    noTables: "Bu alanda henüz masa yok.",
    noOrders: "Bu masada henüz sipariş yok.",
    noPayments: "Bu masada ödeme talebi yok.",
    noGuests: "Bu masaya kişi eklenmedi.",
    save: "Kaydet",
    update: "Güncelle",
    cancel: "Vazgeç",
    close: "Kapat",
    delete: "Sil",
    edit: "Düzenle",
    salonName: "Salon adı",
    salonDesc: "Salon açıklaması",
    tableName: "Masa adı",
    tableNo: "Masa numarası / QR adı",
    tableCapacity: "Kişi kapasitesi",
    tableNote: "Masa notu",
    guestName: "Kişi adı / tanım",
    guestDesc: "Kişi açıklaması",
    guestPlaceholder: "Örn: Ahmet, gözlüklü bey, küçük çocuk",
    guestDescPlaceholder: "Örn: uzun boylu, kırmızı montlu, pencere kenarında",
    quickDesc: "Hazır tanımlar",
    empty: "Boş",
    occupied: "Dolu",
    active: "Aktif",
    payment: "Ödeme Bekliyor",
    paidStatus: "Ödendi",
    reserved: "Rezerve",
    cleaning: "Temizlik",
    locked: "Kapalı",
    markReserved: "Rezerve Yap",
    markCleaning: "Temizlik",
    markLocked: "Kapalı Yap",
    markEmpty: "Boş Yap",
    cashPaid: "Nakit Ödendi",
    cardPaid: "Kart Ödendi",
    reject: "Reddet",
    statusUpdated: "Durum güncellendi.",
    copied: "QR linki kopyalandı.",
    saved: "Kaydedildi.",
    deleted: "Silindi.",
    tokenMissing:
      "Token bulunamadı. Canlı masa verileri çekilemeyebilir.",
    tableSystemInfo:
      "Bu ekran dokunmatik kasa, tablet, Android POS ve mobil kullanım için geniş butonlu tasarlanmıştır.",
    personSystemInfo:
      "Kişileri işletmenin anlayacağı şekilde yazabilirsiniz: Ahmet, Mehmet, gözlüklü adam, küçük çocuk, uzun boylu kişi gibi.",
    liveBoard: "Canlı Masalar",
    reports: "Raporlar",
    training: "Eğitimler",
    tableReports: "Masa Raporları",
    productReports: "Ürün Raporları",
    bestTables: "En Çok Kazandıran Masalar",
    bestProducts: "En Çok Satılan / Kazandıran Ürünler",
    noReportData: "Rapor oluşturmak için henüz yeterli sipariş verisi yok.",
    revenue: "Ciro",
    quantity: "Adet",
    pendingAmount: "Bekleyen Ödeme",
    paidAmount: "Ödenen Tutar",
    howItWorks: "Sistem Nasıl Çalışır?",
    educationTitle: "Canlı Masa Yönetimi Eğitimi",
    educationSubtitle:
      "İşletme sahibi, garson, kasa personeli ve salon sorumlusu bu ekrandan masa sürecini takip eder.",
    deleteInfo:
      "Silme işlemleri eski sipariş ve ödeme kayıtlarını silmez; sadece masa yerleşimini pasife alır.",
    dbConnected: "DB bağlantılı canlı sistem",
    liveRefresh: "Canlı ekran otomatik yenilenir.",
    sureDeleteSalon:
      "Bu salon ve içindeki masalar pasife alınsın mı? Eski siparişler silinmez.",
    sureDeleteTable:
      "Bu masa pasife alınsın mı? Eski siparişler silinmez.",
    sureDeleteGuest: "Bu kişi masadan kaldırılsın mı?",
    sureClearTable:
      "Masa boşaltılsın mı? Kişi notları temizlenir, masa boş duruma alınır.",
  },
  en: {
    pageTitle: "Live Table Management",
    pageSubtitle:
      "Manage halls, tables, guests, bills, payment requests and table performance from one screen.",
    refresh: "Refresh",
    addSalon: "Add Hall",
    editSalon: "Edit Hall",
    addTable: "Add Table",
    editTable: "Edit Table",
    allSalons: "All Halls",
    search: "Search table, hall, guest or note",
    totalTables: "Total Tables",
    activeTables: "Active Tables",
    paymentWaiting: "Payment Waiting",
    emptyTables: "Empty Tables",
    totalRemaining: "Remaining Bill",
    totalRevenue: "Total Revenue",
    totalPaid: "Paid",
    guests: "Guests",
    table: "Table",
    salon: "Hall",
    status: "Status",
    total: "Total",
    paid: "Paid",
    remaining: "Remaining",
    orders: "Orders",
    paymentRequests: "Payment Requests",
    openBill: "Open Bill",
    addGuest: "Add Guest",
    editGuest: "Edit Guest",
    clearTable: "Clear Table",
    copyQr: "Copy QR Link",
    cashPanel: "Open Cash",
    noTables: "No tables in this area yet.",
    noOrders: "No orders for this table yet.",
    noPayments: "No payment requests for this table.",
    noGuests: "No guests added to this table.",
    save: "Save",
    update: "Update",
    cancel: "Cancel",
    close: "Close",
    delete: "Delete",
    edit: "Edit",
    salonName: "Hall name",
    salonDesc: "Hall description",
    tableName: "Table name",
    tableNo: "Table number / QR name",
    tableCapacity: "Capacity",
    tableNote: "Table note",
    guestName: "Guest name / label",
    guestDesc: "Guest description",
    guestPlaceholder: "Ex: John, man with glasses, small child",
    guestDescPlaceholder: "Ex: tall, red jacket, near the window",
    quickDesc: "Quick labels",
    empty: "Empty",
    occupied: "Occupied",
    active: "Active",
    payment: "Payment Waiting",
    paidStatus: "Paid",
    reserved: "Reserved",
    cleaning: "Cleaning",
    locked: "Closed",
    markReserved: "Reserve",
    markCleaning: "Cleaning",
    markLocked: "Close",
    markEmpty: "Set Empty",
    cashPaid: "Cash Paid",
    cardPaid: "Card Paid",
    reject: "Reject",
    statusUpdated: "Status updated.",
    copied: "QR link copied.",
    saved: "Saved.",
    deleted: "Deleted.",
    tokenMissing:
      "Token not found. Live table data may not be loaded.",
    tableSystemInfo:
      "This screen is designed with large touch-friendly buttons for cash registers, tablets, Android POS and mobile devices.",
    personSystemInfo:
      "Guests can be labeled in the way the business understands: John, tall man, child, man with glasses, etc.",
    liveBoard: "Live Tables",
    reports: "Reports",
    training: "Training",
    tableReports: "Table Reports",
    productReports: "Product Reports",
    bestTables: "Top Earning Tables",
    bestProducts: "Top Sold / Earning Products",
    noReportData: "There is not enough order data to generate reports yet.",
    revenue: "Revenue",
    quantity: "Qty",
    pendingAmount: "Pending Payment",
    paidAmount: "Paid Amount",
    howItWorks: "How Does It Work?",
    educationTitle: "Live Table Management Training",
    educationSubtitle:
      "Owner, waiter, cashier and hall manager can follow the full table process from this screen.",
    deleteInfo:
      "Delete actions do not delete old orders or payment records; they only deactivate the layout item.",
    dbConnected: "DB-connected live system",
    liveRefresh: "The live board refreshes automatically.",
    sureDeleteSalon:
      "Deactivate this hall and its tables? Old orders will not be deleted.",
    sureDeleteTable:
      "Deactivate this table? Old orders will not be deleted.",
    sureDeleteGuest: "Remove this guest from the table?",
    sureClearTable:
      "Clear this table? Guest notes will be removed and table will be set to empty.",
  },
  de: {
    pageTitle: "Live-Tischverwaltung",
    pageSubtitle:
      "Säle, Tische, Gäste, Rechnungen, Zahlungsanfragen und Tischleistung auf einem Bildschirm verwalten.",
    refresh: "Aktualisieren",
    addSalon: "Saal hinzufügen",
    editSalon: "Saal bearbeiten",
    addTable: "Tisch hinzufügen",
    editTable: "Tisch bearbeiten",
    allSalons: "Alle Säle",
    search: "Tisch, Saal, Gast oder Notiz suchen",
    totalTables: "Tische gesamt",
    activeTables: "Aktive Tische",
    paymentWaiting: "Zahlung offen",
    emptyTables: "Freie Tische",
    totalRemaining: "Offener Betrag",
    totalRevenue: "Gesamtumsatz",
    totalPaid: "Bezahlt",
    guests: "Gäste",
    table: "Tisch",
    salon: "Saal",
    status: "Status",
    total: "Gesamt",
    paid: "Bezahlt",
    remaining: "Offen",
    orders: "Bestellungen",
    paymentRequests: "Zahlungsanfragen",
    openBill: "Rechnung öffnen",
    addGuest: "Gast hinzufügen",
    editGuest: "Gast bearbeiten",
    clearTable: "Tisch leeren",
    copyQr: "QR-Link kopieren",
    cashPanel: "Kasse öffnen",
    noTables: "In diesem Bereich gibt es noch keine Tische.",
    noOrders: "Für diesen Tisch gibt es noch keine Bestellung.",
    noPayments: "Für diesen Tisch gibt es keine Zahlungsanfrage.",
    noGuests: "Diesem Tisch wurden keine Gäste hinzugefügt.",
    save: "Speichern",
    update: "Aktualisieren",
    cancel: "Abbrechen",
    close: "Schließen",
    delete: "Löschen",
    edit: "Bearbeiten",
    salonName: "Saalname",
    salonDesc: "Saalbeschreibung",
    tableName: "Tischname",
    tableNo: "Tischnummer / QR-Name",
    tableCapacity: "Kapazität",
    tableNote: "Tischnotiz",
    guestName: "Gastname / Bezeichnung",
    guestDesc: "Gastbeschreibung",
    guestPlaceholder: "z. B. Ahmet, Mann mit Brille, kleines Kind",
    guestDescPlaceholder: "z. B. groß, rote Jacke, am Fenster",
    quickDesc: "Schnellbezeichnungen",
    empty: "Frei",
    occupied: "Besetzt",
    active: "Aktiv",
    payment: "Zahlung offen",
    paidStatus: "Bezahlt",
    reserved: "Reserviert",
    cleaning: "Reinigung",
    locked: "Geschlossen",
    markReserved: "Reservieren",
    markCleaning: "Reinigung",
    markLocked: "Schließen",
    markEmpty: "Frei setzen",
    cashPaid: "Bar bezahlt",
    cardPaid: "Karte bezahlt",
    reject: "Ablehnen",
    statusUpdated: "Status aktualisiert.",
    copied: "QR-Link kopiert.",
    saved: "Gespeichert.",
    deleted: "Gelöscht.",
    tokenMissing:
      "Token nicht gefunden. Live-Tischdaten können evtl. nicht geladen werden.",
    tableSystemInfo:
      "Dieser Bildschirm ist mit großen Touch-Buttons für Kasse, Tablet, Android POS und Mobilgeräte gestaltet.",
    personSystemInfo:
      "Gäste können so bezeichnet werden, wie der Betrieb sie erkennt: Ahmet, großer Mann, Kind, Mann mit Brille usw.",
    liveBoard: "Live-Tische",
    reports: "Berichte",
    training: "Schulung",
    tableReports: "Tischberichte",
    productReports: "Produktberichte",
    bestTables: "Umsatzstärkste Tische",
    bestProducts: "Meistverkaufte / Umsatzstarke Produkte",
    noReportData: "Es gibt noch nicht genug Bestelldaten für Berichte.",
    revenue: "Umsatz",
    quantity: "Menge",
    pendingAmount: "Offene Zahlung",
    paidAmount: "Bezahlter Betrag",
    howItWorks: "Wie funktioniert es?",
    educationTitle: "Schulung Live-Tischverwaltung",
    educationSubtitle:
      "Inhaber, Kellner, Kassierer und Saalverantwortliche verfolgen den kompletten Tischprozess auf diesem Bildschirm.",
    deleteInfo:
      "Löschaktionen entfernen keine alten Bestellungen oder Zahlungen; sie deaktivieren nur das Layout-Element.",
    dbConnected: "Live-System mit DB-Verbindung",
    liveRefresh: "Die Live-Ansicht aktualisiert sich automatisch.",
    sureDeleteSalon:
      "Diesen Saal und seine Tische deaktivieren? Alte Bestellungen werden nicht gelöscht.",
    sureDeleteTable:
      "Diesen Tisch deaktivieren? Alte Bestellungen werden nicht gelöscht.",
    sureDeleteGuest: "Diesen Gast vom Tisch entfernen?",
    sureClearTable:
      "Tisch leeren? Gästenotizen werden entfernt und der Tisch wird auf frei gesetzt.",
  },
};

const DESC_TEMPLATES = {
  tr: [
    "Uzun boylu",
    "Gözlüklü",
    "Küçük çocuk",
    "Kırmızı montlu",
    "Pencere kenarı",
    "Aile",
    "Tek kişi",
    "Kalabalık grup",
  ],
  en: [
    "Tall person",
    "With glasses",
    "Small child",
    "Red jacket",
    "Near window",
    "Family",
    "Single guest",
    "Large group",
  ],
  de: [
    "Große Person",
    "Mit Brille",
    "Kleines Kind",
    "Rote Jacke",
    "Am Fenster",
    "Familie",
    "Einzelgast",
    "Große Gruppe",
  ],
};

const TRAINING = {
  tr: [
    {
      title: "1. Salon ve masa düzeni",
      text:
        "Önce işletmedeki alanları oluşturun: Ana Salon, Bahçe, Teras, Üst Kat gibi. Her salonun içine masa ekleyin. Yanlış açılan masa veya salon silinebilir; eski sipariş kayıtları silinmez.",
    },
    {
      title: "2. Masaya kişi ekleme",
      text:
        "Müşterileri gerçek isimle yazmak zorunda değilsiniz. İşletmenin tanıyacağı şekilde Ahmet, Mehmet, gözlüklü bey, küçük çocuk, uzun boylu kişi gibi not ekleyebilirsiniz.",
    },
    {
      title: "3. QR ve sipariş akışı",
      text:
        "Masa QR linki kopyalanır ve o masaya özel QR hazırlanır. Müşteri QR menüden sipariş verdiğinde sipariş bu ekranda ilgili masanın içine düşer.",
    },
    {
      title: "4. Hesap ve ödeme talebi",
      text:
        "Müşteri hesabını görmek veya ödeme talebi göndermek istediğinde talep masada görünür. İşletme nakit ödendi, kart ödendi veya reddet seçenekleriyle işlemi tamamlar.",
    },
    {
      title: "5. Masa kapatma",
      text:
        "Hesap kapandıktan sonra Masayı Boşalt kullanılır. Bu işlem kişi notlarını temizler ve masayı boş duruma alır.",
    },
    {
      title: "6. Raporlar",
      text:
        "Raporlar bölümünde en çok ciro yapan masalar, en çok satılan ürünler, ödenen ve bekleyen ödeme talepleri görülebilir.",
    },
  ],
  en: [
    {
      title: "1. Hall and table layout",
      text:
        "Create business areas first: Main Hall, Garden, Terrace, Upper Floor. Add tables inside each hall. Wrongly created halls or tables can be deleted; old order records are not deleted.",
    },
    {
      title: "2. Adding guests to a table",
      text:
        "You do not have to use real names. You can write practical labels such as John, man with glasses, small child or tall person.",
    },
    {
      title: "3. QR and order flow",
      text:
        "Copy the table QR link and prepare a QR for that table. When the guest orders from the QR menu, the order appears under the matching table.",
    },
    {
      title: "4. Bill and payment request",
      text:
        "When the guest wants to view or pay the bill, the request appears on the table. The business completes it with Cash Paid, Card Paid or Reject.",
    },
    {
      title: "5. Closing the table",
      text:
        "After the bill is closed, use Clear Table. This removes guest notes and sets the table to empty.",
    },
    {
      title: "6. Reports",
      text:
        "Reports show top earning tables, best-selling products, paid amounts and pending payment requests.",
    },
  ],
  de: [
    {
      title: "1. Saal- und Tischstruktur",
      text:
        "Erstellen Sie zuerst Bereiche wie Hauptsaal, Garten, Terrasse oder Obergeschoss. Fügen Sie jedem Bereich Tische hinzu. Falsch angelegte Tische oder Säle können gelöscht werden; alte Bestellungen bleiben erhalten.",
    },
    {
      title: "2. Gäste zum Tisch hinzufügen",
      text:
        "Sie müssen keine echten Namen verwenden. Sie können praktische Bezeichnungen wie Ahmet, Mann mit Brille, kleines Kind oder große Person nutzen.",
    },
    {
      title: "3. QR- und Bestellablauf",
      text:
        "Kopieren Sie den QR-Link des Tisches und erstellen Sie einen QR-Code für diesen Tisch. Bestellungen aus dem QR-Menü erscheinen direkt beim passenden Tisch.",
    },
    {
      title: "4. Rechnung und Zahlungsanfrage",
      text:
        "Wenn der Gast die Rechnung sehen oder zahlen möchte, erscheint die Anfrage beim Tisch. Der Betrieb schließt sie mit Bar bezahlt, Karte bezahlt oder Ablehnen ab.",
    },
    {
      title: "5. Tisch schließen",
      text:
        "Nach Abschluss der Rechnung nutzen Sie Tisch leeren. Dadurch werden Gästenotizen entfernt und der Tisch wird frei gesetzt.",
    },
    {
      title: "6. Berichte",
      text:
        "Berichte zeigen umsatzstärkste Tische, meistverkaufte Produkte, bezahlte Beträge und offene Zahlungsanfragen.",
    },
  ],
};

function getPanelLang() {
  const raw =
    localStorage.getItem("panel_dili") ||
    localStorage.getItem("app_lang") ||
    localStorage.getItem("lang") ||
    "tr";

  const lang = String(raw).slice(0, 2).toLowerCase();
  return ["tr", "en", "de"].includes(lang) ? lang : "tr";
}

function getToken() {
  return (
    localStorage.getItem(
      "token"
    ) ||
    localStorage.getItem(
      "authToken"
    ) ||
    localStorage.getItem(
      "access_token"
    ) ||
    localStorage.getItem(
      "adminToken"
    ) ||
    ""
  );
}

function getTokenKurumId(
  tokenValue
) {
  try {
    const payloadPart =
      String(
        tokenValue ||
          ""
      ).split(".")[1];

    if (!payloadPart) {
      return null;
    }

    const normalized =
      payloadPart
        .replace(
          /-/g,
          "+"
        )
        .replace(
          /_/g,
          "/"
        );

    const padded =
      normalized.padEnd(
        Math.ceil(
          normalized.length /
            4
        ) * 4,

        "="
      );

    const payload =
      JSON.parse(
        decodeURIComponent(
          window
            .atob(
              padded
            )
            .split("")
            .map(
              (
                character
              ) =>
                `%${character
                  .charCodeAt(
                    0
                  )
                  .toString(
                    16
                  )
                  .padStart(
                    2,
                    "0"
                  )}`
            )
            .join("")
        )
      );

    return (
      payload.kurum_id ||
      payload.kurumId ||
      payload.institution_id ||
      null
    );
  } catch (error) {
    console.error(
      "Token kurum ID okunamadı:",
      error
    );

    return null;
  }
}

function normalizeCurrency(value) {
  const c = String(value || "TRY").toUpperCase();
  return c === "TL" ? "TRY" : c;
}

function getLocale(lang) {
  if (lang === "en") return "en-US";
  if (lang === "de") return "de-DE";
  return "tr-TR";
}

function moneyText(value, currency = "TRY", lang = "tr") {
  const n = Number(value || 0);
  return `${n.toLocaleString(getLocale(lang), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${normalizeCurrency(currency)}`;
}

function safeArray(value) {
  if (Array.isArray(value)) return value;

  try {
    const parsed = JSON.parse(value || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function safeNumber(value) {
  const n = Number(value || 0);
  return Number.isFinite(n) ? n : 0;
}

function safePrice(value, fallback = 0) {
  const normalized =
    typeof value === "string"
      ? value.trim().replace(",", ".")
      : value;

  const n = Number(normalized);

  return Number.isFinite(n) ? n : fallback;
}

function getLocalizedMenuValue(row, prefix, lang = "tr") {
  const supportedLanguages = [
    "tr",
    "en",
    "de",
    "ar",
    "fa",
    "ru",
    "sq",
    "es",
    "pt",
  ];

  const requestedLanguage = String(lang || "").toLowerCase();

  const safeLang = supportedLanguages.includes(requestedLanguage)
    ? requestedLanguage
    : "tr";

  const keys = [
    `${prefix}_${safeLang}`,
    `${prefix}_tr`,
    `${prefix}_en`,
    `${prefix}_de`,
    prefix,
  ];

  for (const key of keys) {
    const value = row?.[key];

    if (
      value !== undefined &&
      value !== null &&
      String(value).trim() !== ""
    ) {
      return value;
    }
  }

  return "";
}

function normalizeMenuPriceOptions(value) {
  return safeArray(value)
    .map((option, index) => ({
      id: option?.id || `option-${index}`,

      label: String(
        option?.label ||
          option?.name ||
          option?.title ||
          ""
      ).trim(),

      price: safePrice(
        option?.price ?? option?.fiyat,
        NaN
      ),

      currency: normalizeCurrency(
        option?.currency ||
          option?.para_birimi ||
          "TRY"
      ),
    }))
    .filter(
      (option) =>
        option.label &&
        Number.isFinite(option.price) &&
        option.price >= 0
    );
}

function normTable(value) {


  const cleaned = String(value || "")
    .trim()
    .toLocaleLowerCase("tr-TR")
    .replace(/masası/g, "")
    .replace(/masa/g, "")
    .replace(/table/g, "")
    .replace(/tisch/g, "")
    .replace(/\bnolu\b/g, "")
    .replace(/\bno\b/g, "")
    .replace(/\bnumara\b/g, "")
    .replace(/\bnummer\b/g, "")
    .replace(/\s+/g, "")
    .replace(/[^a-z0-9ığüşöç]/g, "");

  /*
   * 01 ile 1, 002 ile 2 aynı masa kabul edilir.
   */
  return cleaned.replace(/\d+/g, (numberPart) =>
    String(Number(numberPart))
  );
}



function normalizeOrder(order) {
  const items = safeArray(order?.items);

  return {
    ...order,
    items,
    toplam_tutar: safeNumber(order?.toplam_tutar || order?.total_amount || 0),
    currency: normalizeCurrency(
      order?.currency ||
        order?.para_birimi ||
        items.find((x) => x.currency)?.currency ||
        "TRY"
    ),
  };
}

function normalizePaymentRequest(req) {
  return {
    ...req,
    amount: safeNumber(req?.amount || req?.tutar || 0),
    base_amount: safeNumber(req?.base_amount || 0),
    tip_amount: safeNumber(req?.tip_amount || 0),
    selected_items: safeArray(req?.selected_items),
    currency: normalizeCurrency(req?.currency || "TRY"),
  };
}

function getStatusConfig(status, TT, theme) {
  const map = {
    empty: {
      label: TT.empty,
      color: theme.palette.grey[600],
      bg: alpha(theme.palette.grey[500], 0.08),
      border: alpha(theme.palette.grey[500], 0.2),
      chip: "default",
      icon: "⚪",
    },
    occupied: {
      label: TT.occupied,
      color: BRAND.blue,
      bg: alpha(BRAND.blue, 0.08),
      border: alpha(BRAND.blue, 0.22),
      chip: "primary",
      icon: "👥",
    },
    active: {
      label: TT.active,
      color: BRAND.orange,
      bg: alpha(BRAND.orange, 0.09),
      border: alpha(BRAND.orange, 0.24),
      chip: "warning",
      icon: "🔥",
    },
    payment: {
      label: TT.payment,
      color: theme.palette.error.main,
      bg: alpha(theme.palette.error.main, 0.08),
      border: alpha(theme.palette.error.main, 0.22),
      chip: "error",
      icon: "💳",
    },
    paid: {
      label: TT.paidStatus,
      color: theme.palette.success.main,
      bg: alpha(theme.palette.success.main, 0.08),
      border: alpha(theme.palette.success.main, 0.22),
      chip: "success",
      icon: "✅",
    },
    reserved: {
      label: TT.reserved,
      color: theme.palette.info.main,
      bg: alpha(theme.palette.info.main, 0.08),
      border: alpha(theme.palette.info.main, 0.22),
      chip: "info",
      icon: "📌",
    },
    cleaning: {
      label: TT.cleaning,
      color: theme.palette.secondary.main,
      bg: alpha(theme.palette.secondary.main, 0.08),
      border: alpha(theme.palette.secondary.main, 0.22),
      chip: "secondary",
      icon: "🧹",
    },
    locked: {
      label: TT.locked,
      color: theme.palette.grey[800],
      bg: alpha(theme.palette.grey[800], 0.08),
      border: alpha(theme.palette.grey[800], 0.22),
      chip: "default",
      icon: "⛔",
    },
  };

  return map[status] || map.empty;
}

function getItemTitle(item) {
  return (
    item?.display_title ||
    item?.title ||
    item?.urun_adi ||
    item?.name ||
    item?.ad ||
    "-"
  );
}

function getItemQty(item) {
  return safeNumber(item?.quantity || item?.adet || item?.qty || 1, 1);
}

function getItemPrice(item) {
  return safeNumber(item?.price || item?.fiyat || item?.unit_price || 0);
}

function getItemLineTotal(item) {
  const direct = safeNumber(item?.line_total || item?.total || item?.tutar || 0);
  if (direct > 0) return direct;
  return getItemQty(item) * getItemPrice(item);
}

export default function MasaYonetimiPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [lang, setLang] = useState(getPanelLang());
  const TT = TEXT[lang] || TEXT.tr;

  const [activePanel, setActivePanel] = useState("live");
  const [layout, setLayout] = useState({
    salons: [],
    tables: [],
    guests: [],
  });
  const [selectedSalonId, setSelectedSalonId] = useState("all");
  const [search, setSearch] = useState("");

  const [orders, setOrders] = useState([]);
  const [paymentRequests, setPaymentRequests] = useState([]);

const [stockItems, setStockItems] = useState([]);

const [menuCategories, setMenuCategories] = useState([]);
const [menuLoading, setMenuLoading] = useState(false);
const [selectedMenuCategoryId, setSelectedMenuCategoryId] =
  useState("all");

const [manualDialog, setManualDialog] = useState(false);
const [manualSearch, setManualSearch] = useState("");
const [manualBasket, setManualBasket] = useState([]);
const [manualNote, setManualNote] = useState("");

const [transferDialog, setTransferDialog] = useState(false);
const [transferSourceTableId, setTransferSourceTableId] =
  useState(null);
const [transferTargetTableId, setTransferTargetTableId] =
  useState("");
const [transferLoading, setTransferLoading] = useState(false);


const [customItemForm, setCustomItemForm] = useState({
  title: "",
  price: "",
  quantity: "1",
  currency: "TRY",
});

  const [loading, setLoading] = useState(false);

  const [selectedTableId, setSelectedTableId] = useState(null);

  const [salonDialog, setSalonDialog] = useState(false);
  const [tableDialog, setTableDialog] = useState(false);
  const [guestDialog, setGuestDialog] = useState(false);

  const [editingSalonId, setEditingSalonId] = useState(null);
  const [editingTableId, setEditingTableId] = useState(null);
  const [editingGuestId, setEditingGuestId] = useState(null);

  const [salonForm, setSalonForm] = useState({
    name: "",
    description: "",
    color: BRAND.blue,
  });

  const [tableForm, setTableForm] = useState({
    salon_id: "",
    name: "",
    masa_no: "",
    capacity: 4,
    note: "",
  });

  const [guestForm, setGuestForm] = useState({
    name: "",
    description: "",
  });

  const [snack, setSnack] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const token = getToken();

  const notify = useCallback((message, severity = "success") => {
    setSnack({
      open: true,
      severity,
      message,
    });
  }, []);

  const authHeaders = useCallback(() => {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  }, [token]);

 const loadLiveData = useCallback(async () => {
  if (!token) {
    notify(TT.tokenMissing, "warning");
    return;
  }

  setLoading(true);

  try {
    /*
     * Salon, masa, kişi ve ödeme talepleri canlı masa endpointinden gelir.
     * Siparişler ise çalışan SiparişPage ile aynı /qr-orders endpointinden gelir.
     */
    const [liveRes, ordersRes] = await Promise.all([
      fetch(`${API_BASE}/masacanli/live`, {
        headers: authHeaders(),
      }),

      fetch(`${API_BASE}/qr-orders`, {
        headers: authHeaders(),
      }).catch(() => null),
    ]);

    const liveJson = await liveRes.json().catch(() => ({}));

    if (!liveRes.ok || liveJson?.ok === false) {
      throw new Error(
        liveJson?.message || "Canlı masa verisi alınamadı"
      );
    }

    const data = liveJson.data || {};

    setLayout({
      salons: Array.isArray(data.salons)
        ? data.salons
        : [],

      tables: Array.isArray(data.tables)
        ? data.tables
        : [],

      guests: Array.isArray(data.guests)
        ? data.guests
        : [],
    });

    /*
     * /qr-orders cevap vermezse canlı endpointteki siparişler
     * yedek olarak kullanılmaya devam eder.
     */
    let orderRows = Array.isArray(data.orders)
      ? data.orders
      : [];

    if (ordersRes) {
      const ordersJson = await ordersRes
        .json()
        .catch(() => ({}));

      if (
        ordersRes.ok &&
        ordersJson?.ok !== false &&
        Array.isArray(ordersJson.data)
      ) {
        orderRows = ordersJson.data;
      } else {
        console.warn(
          "Masa yönetimi /qr-orders cevabı kullanılamadı. Canlı veri kullanılıyor.",
          ordersJson
        );
      }
    }

    setOrders(
      orderRows.map(normalizeOrder)
    );

    setPaymentRequests(
      (
        data.paymentRequests ||
        data.payment_requests ||
        []
      ).map(normalizePaymentRequest)
    );
  } catch (err) {
    console.error(
      "Masa yönetimi canlı veri hatası:",
      err
    );

    notify(
      err.message || "Canlı veriler alınamadı.",
      "error"
    );
  } finally {
    setLoading(false);
  }
}, [
  TT.tokenMissing,
  authHeaders,
  notify,
  token,
]);



const fetchStockItems = useCallback(async () => {
  if (!token) return;

  try {
    const res = await fetch(`${API_BASE}/stock/items`, {
      headers: authHeaders(),
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json?.ok === false) {
      throw new Error(json?.message || "Stok listesi alınamadı");
    }

    const rawRows = Array.isArray(json.data)
      ? json.data
      : Array.isArray(json)
      ? json
      : [];

    const rows = rawRows
      .filter((item) => item && item.active !== false)
      .map((item) => {
        const title =
          item.name ||
          item.title ||
          item.urun_adi ||
          item.product_name ||
          "";

        return {
          ...item,
          id: item.backend_id || item.id,
          title,
          urun_adi: title,
          stock: Number(
            item.current_stock ??
              item.stok_adedi ??
              item.stock ??
              item.quantity ??
              0
          ),
          price: Number(
            item.sale_price ??
              item.satis_fiyati ??
              item.price ??
              item.fiyat ??
              0
          ),
          currency: item.currency || item.para_birimi || "TRY",
        };
      })
      .filter((item) => String(item.title || "").trim());

    setStockItems(rows);
  } catch (err) {
    console.error("Stok ürünleri alınamadı:", err);
    setStockItems([]);
  }


}, [authHeaders, token]);

const fetchMenuCatalog = useCallback(async () => {
  if (!token) return;

  setMenuLoading(true);

  try {
    const [sectionsRes, categoriesRes, itemsRes] =
      await Promise.all([
        fetch(`${API_BASE}/extra-sections`, {
          headers: authHeaders(),
        }),

        fetch(`${API_BASE}/extra-categories`, {
          headers: authHeaders(),
        }),

        fetch(`${API_BASE}/extra-items`, {
          headers: authHeaders(),
        }),
      ]);

    const [sectionsJson, categoriesJson, itemsJson] =
      await Promise.all([
        sectionsRes.json().catch(() => ({})),
        categoriesRes.json().catch(() => ({})),
        itemsRes.json().catch(() => ({})),
      ]);

    if (
      !sectionsRes.ok ||
      !categoriesRes.ok ||
      !itemsRes.ok
    ) {
      throw new Error(
        sectionsJson?.message ||
          categoriesJson?.message ||
          itemsJson?.message ||
          "Menü listesi alınamadı"
      );
    }

    const sections = (
      Array.isArray(sectionsJson?.data)
        ? sectionsJson.data
        : []
    )
      .filter(
        (section) =>
          section &&
          section.aktif !== false
      )
      .sort(
        (a, b) =>
          Number(a.sira ?? 9999) -
            Number(b.sira ?? 9999) ||
          Number(a.id || 0) -
            Number(b.id || 0)
      );

    const sectionMap = new Map(
      sections.map((section) => [
        String(section.id),
        section,
      ])
    );

    const categories = (
      Array.isArray(categoriesJson?.data)
        ? categoriesJson.data
        : []
    )
      .filter(
        (category) =>
          category &&
          category.aktif !== false &&
          sectionMap.has(
            String(category.section_id)
          )
      )
      .sort((a, b) => {
        const sectionA = sectionMap.get(
          String(a.section_id)
        );

        const sectionB = sectionMap.get(
          String(b.section_id)
        );

        return (
          Number(sectionA?.sira ?? 9999) -
            Number(sectionB?.sira ?? 9999) ||
          Number(a.sira ?? 9999) -
            Number(b.sira ?? 9999) ||
          Number(a.id || 0) -
            Number(b.id || 0)
        );
      });

    const rawItems = (
      Array.isArray(itemsJson?.data)
        ? itemsJson.data
        : []
    ).filter(
      (item) =>
        item &&
        item.aktif !== false
    );

    const catalog = categories
      .map((category) => {
        const section = sectionMap.get(
          String(category.section_id)
        );

        const title = String(
          getLocalizedMenuValue(
            category,
            "title",
            lang
          ) ||
            getLocalizedMenuValue(
              section,
              "title",
              lang
            ) ||
            section?.category_key ||
            "Menü"
        ).trim();

        const categoryItems = rawItems
          .filter(
            (item) =>
              String(item.category_id) ===
              String(category.id)
          )
          .sort(
            (a, b) =>
              Number(a.sira ?? 9999) -
                Number(b.sira ?? 9999) ||
              Number(a.id || 0) -
                Number(b.id || 0)
          )
          .map((item) => ({
            ...item,

            id: item.id,
            menu_item_id: item.id,

            category_id: category.id,
            category_title: title,

            title: String(
              getLocalizedMenuValue(
                item,
                "title",
                lang
              ) || ""
            ).trim(),

            price: safePrice(
              getLocalizedMenuValue(
                item,
                "price",
                lang
              ),
              0
            ),

            currency: normalizeCurrency(
              getLocalizedMenuValue(
                item,
                "currency",
                lang
              ) || "TRY"
            ),

            price_options:
              normalizeMenuPriceOptions(
                item.price_options
              ),
          }))
          .filter((item) => item.title);

        return {
          id: category.id,
          section_id: category.section_id,
          title,

          image:
            category.image ||
            section?.image ||
            "",

          items: categoryItems,
        };
      })
      .filter(
        (category) =>
          category.items.length > 0
      );

    setMenuCategories(catalog);

    setSelectedMenuCategoryId((current) => {
      if (
        current !== "all" &&
        catalog.some(
          (category) =>
            String(category.id) ===
            String(current)
        )
      ) {
        return current;
      }

      return "all";
    });
  } catch (err) {
    console.error(
      "Menü ürünleri alınamadı:",
      err
    );

    setMenuCategories([]);

    notify(
      err?.message ||
        "Menü ürünleri alınamadı",
      "error"
    );
  } finally {
    setMenuLoading(false);
  }
}, [authHeaders, lang, notify, token]);

useEffect(() => {
  loadLiveData();
  fetchStockItems();

  const timer = setInterval(() => {
    loadLiveData();
    fetchStockItems();
  }, 8000);

  return () => clearInterval(timer);
}, [fetchStockItems, loadLiveData]);

  const salons = layout.salons || [];
  const tables = layout.tables || [];
  const guests = layout.guests || [];




const tableStatsMap = useMemo(() => {
  const map = {};

  tables.forEach((table) => {
    /*
     * Tek bir masa adı seçmek yerine masanın bütün
     * olası adlarını eşleştirmede kullanıyoruz.
     *
     * Örnek:
     * name: "Masa 1"
     * masa_no: "01"
     * table_no: "1"
     *
     * Bunların tamamı aynı masaya bağlanabilir.
     */
    const tableKeys = new Set(
      [
        table?.masa_no,
        table?.table_no,
        table?.name,
        table?.masa_adi,
        table?.table_name,
        table?.qr_masa_no,
      ]
        .map(normTable)
        .filter(Boolean)
    );

    const belongsToTable = (record) => {
      /*
       * Backend kaydında doğrudan masa ID bulunuyorsa
       * öncelikle onunla eşleştir.
       */
      const recordTableId =
        record?.table_id ??
        record?.masa_id ??
        record?.tableId ??
        record?.masaId ??
        null;

      if (
        recordTableId !== null &&
        recordTableId !== undefined &&
        String(recordTableId) === String(table.id)
      ) {
        return true;
      }

      /*
       * PublicMenu siparişleri masa ID yerine masa adı/no
       * gönderdiği için bütün olası alanları karşılaştır.
       */
      const recordKeys = [
        record?.masa_no,
        record?.table_no,
        record?.masa,
        record?.table,
        record?.masa_adi,
        record?.table_name,
        record?.qr_masa_no,
      ]
        .map(normTable)
        .filter(Boolean);

      return recordKeys.some((recordKey) =>
        tableKeys.has(recordKey)
      );
    };

    const tableGuests = guests.filter(
      (guest) =>
        String(
          guest?.table_id ??
            guest?.masa_id ??
            ""
        ) === String(table.id)
    );

    const tableOrders = orders.filter((order) => {
      const orderStatus = String(
        order?.durum ||
          order?.status ||
          ""
      )
        .trim()
        .toLocaleLowerCase("tr-TR");

      if (
        [
          "iptal",
          "cancelled",
          "canceled",
        ].includes(orderStatus)
      ) {
        return false;
      }

      return belongsToTable(order);
    });

    const tablePayments = paymentRequests.filter(
      (paymentRequest) =>
        belongsToTable(paymentRequest)
    );

    const pendingPayments = tablePayments.filter(
      (payment) =>
        [
          "bekliyor",
          "pending",
        ].includes(
          String(
            payment?.status || ""
          )
            .trim()
            .toLocaleLowerCase("tr-TR")
        )
    );

    const paidPayments = tablePayments.filter(
      (payment) =>
        [
          "odendi",
          "ödendi",
          "onaylandi",
          "onaylandı",
          "paid",
        ].includes(
          String(
            payment?.status || ""
          )
            .trim()
            .toLocaleLowerCase("tr-TR")
        )
    );

    const total = tableOrders.reduce(
      (sum, order) =>
        sum +
        safeNumber(
          order?.toplam_tutar ??
            order?.total_amount ??
            order?.total ??
            0
        ),
      0
    );

    const paid = paidPayments.reduce(
      (sum, payment) =>
        sum +
        safeNumber(
          payment?.amount ??
            payment?.tutar ??
            0
        ),
      0
    );

    const pendingAmount = pendingPayments.reduce(
      (sum, payment) =>
        sum +
        safeNumber(
          payment?.amount ??
            payment?.tutar ??
            0
        ),
      0
    );

    const remaining = Math.max(
      total - paid,
      0
    );

    let status = "empty";

    if (pendingPayments.length > 0) {
      status = "payment";
    } else if (
      tableOrders.length > 0 &&
      remaining > 0
    ) {
      status = "active";
    } else if (
      tableOrders.length > 0 &&
      remaining <= 0
    ) {
      status = "paid";
    } else if (tableGuests.length > 0) {
      status = "occupied";
    } else if (
      table?.manual_status &&
      table.manual_status !== "empty"
    ) {
      status = table.manual_status;
    }

    map[table.id] = {
      table,

      orders: tableOrders,

      payments: tablePayments,

      pendingPayments,

      paidPayments,

      guests: tableGuests,

      total,

      paid,

      pendingAmount,

      remaining,

      currency:
        tableOrders.find(
          (order) => order?.currency
        )?.currency ||
        tablePayments.find(
          (payment) => payment?.currency
        )?.currency ||
        "TRY",

      status,
    };
  });

  return map;
}, [
  tables,
  guests,
  orders,
  paymentRequests,
]);

  const filteredTables = useMemo(() => {
    const q = String(search || "").toLowerCase().trim();

    return tables.filter((table) => {
      if (
        selectedSalonId !== "all" &&
        String(table.salon_id) !== String(selectedSalonId)
      ) {
        return false;
      }

      if (!q) return true;

      const salon = salons.find((s) => String(s.id) === String(table.salon_id));
      const stat = tableStatsMap[table.id];

      const guestText = (stat?.guests || [])
        .map((g) => `${g.name || g.kisi_adi} ${g.description || g.kisi_tanimi}`)
        .join(" ")
        .toLowerCase();

      return (
        String(table.name || table.masa_adi || "").toLowerCase().includes(q) ||
        String(table.masa_no || "").toLowerCase().includes(q) ||
        String(table.note || table.notlar || "").toLowerCase().includes(q) ||
        String(salon?.name || salon?.salon_adi || "").toLowerCase().includes(q) ||
        guestText.includes(q)
      );
    });
  }, [tables, selectedSalonId, search, salons, tableStatsMap]);

  const summary = useMemo(() => {
    const stats = Object.values(tableStatsMap);

    return {
      totalTables: tables.length,
      activeTables: stats.filter((s) =>
        ["active", "occupied", "payment"].includes(s.status)
      ).length,
      paymentWaiting: stats.filter((s) => s.status === "payment").length,
      emptyTables: stats.filter((s) => s.status === "empty").length,
      totalRevenue: stats.reduce((sum, s) => sum + safeNumber(s.total), 0),
      totalPaid: stats.reduce((sum, s) => sum + safeNumber(s.paid), 0),
      totalRemaining: stats.reduce((sum, s) => sum + safeNumber(s.remaining), 0),
      totalPending: stats.reduce(
        (sum, s) => sum + safeNumber(s.pendingAmount),
        0
      ),
      totalGuests: guests.length,
    };
  }, [tables.length, guests.length, tableStatsMap]);

  const reports = useMemo(() => {
    const tableRows = Object.values(tableStatsMap)
      .map((s) => ({
        id: s.table.id,
        name: s.table.name || s.table.masa_adi || "-",
        salonName:
          salons.find((x) => String(x.id) === String(s.table.salon_id))?.name ||
          "-",
        revenue: s.total,
        paid: s.paid,
        pending: s.pendingAmount,
        orders: s.orders.length,
        currency: s.currency,
      }))
      .sort((a, b) => b.revenue - a.revenue);

    const productMap = {};

    orders.forEach((order) => {
      const currency = order.currency || "TRY";

      (order.items || []).forEach((item) => {
        const title = getItemTitle(item);
        const qty = getItemQty(item);
        const lineTotal = getItemLineTotal(item);

        if (!productMap[title]) {
          productMap[title] = {
            title,
            qty: 0,
            revenue: 0,
            currency,
          };
        }

        productMap[title].qty += qty;
        productMap[title].revenue += lineTotal;
      });
    });

    const productRows = Object.values(productMap).sort(
      (a, b) => b.revenue - a.revenue
    );

    return {
      tableRows,
      productRows,
      maxTableRevenue: Math.max(...tableRows.map((r) => r.revenue), 0),
      maxProductRevenue: Math.max(...productRows.map((r) => r.revenue), 0),
    };
  }, [orders, salons, tableStatsMap]);

  const selectedTable = selectedTableId
    ? tables.find((t) => String(t.id) === String(selectedTableId))
    : null;

  const selectedSalon = selectedTable
    ? salons.find((s) => String(s.id) === String(selectedTable.salon_id))
    : null;

 const selectedStats = selectedTable
  ? tableStatsMap[selectedTable.id]
  : null;

const transferSourceTable =
  transferSourceTableId
    ? tables.find(
        (table) =>
          String(table.id) ===
          String(transferSourceTableId)
      )
    : null;

const transferCandidateTables = useMemo(() => {
  const sourceTable = tables.find(
    (table) =>
      String(table.id) ===
      String(transferSourceTableId)
  );

  return tables
    .filter((table) => {
      if (
        String(table.id) ===
        String(transferSourceTableId)
      ) {
        return false;
      }

      if (
        sourceTable?.sube_id &&
        table?.sube_id &&
        String(sourceTable.sube_id) !==
          String(table.sube_id)
      ) {
        return false;
      }

      return (
        tableStatsMap[table.id]?.status ===
        "empty"
      );
    })
    .sort((a, b) => {
      const salonA = salons.find(
        (salon) =>
          String(salon.id) ===
          String(a.salon_id)
      );

      const salonB = salons.find(
        (salon) =>
          String(salon.id) ===
          String(b.salon_id)
      );

      const labelA = `${
        salonA?.name ||
        salonA?.salon_adi ||
        ""
      } ${a.name || a.masa_adi || ""}`;

      const labelB = `${
        salonB?.name ||
        salonB?.salon_adi ||
        ""
      } ${b.name || b.masa_adi || ""}`;

      return labelA.localeCompare(
        labelB,
        "tr"
      );
    });
}, [
  salons,
  tableStatsMap,
  tables,
  transferSourceTableId,
]);

const openAddSalon = () => {


    setEditingSalonId(null);
    setSalonForm({
      name: "",
      description: "",
      color: salons.length % 2 === 0 ? BRAND.blue : BRAND.orange,
    });
    setSalonDialog(true);
  };

  const openEditSalon = (salon) => {
    setEditingSalonId(salon.id);
    setSalonForm({
      name: salon.name || salon.salon_adi || "",
      description: salon.description || salon.aciklama || "",
      color: salon.color || salon.renk || BRAND.blue,
    });
    setSalonDialog(true);
  };

  const saveSalon = async () => {
    const cleanName = String(salonForm.name || "").trim();

    if (!cleanName || !token) return;

    try {
      const url = editingSalonId
        ? `${API_BASE}/masacanli/salonlar/${editingSalonId}`
        : `${API_BASE}/masacanli/salonlar`;

      const res = await fetch(url, {
        method: editingSalonId ? "PUT" : "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          name: cleanName,
          description: salonForm.description || "",
          color: salonForm.color || BRAND.blue,
        }),
      });

      const json = await res.json().catch(() => ({}));

      if (!res.ok || json?.ok === false) {
        throw new Error(json?.message || "Salon kaydedilemedi");
      }

      if (!editingSalonId) {
        setSelectedSalonId(json.data?.id || "all");
      }

      setSalonDialog(false);
      notify(editingSalonId ? TT.statusUpdated : TT.saved);
      loadLiveData();


    } catch (err) {
      console.error("Salon kaydetme hatası:", err);
      notify(err.message || "Salon kaydedilemedi", "error");
    }
  };

  const deleteSalon = async (salonId) => {




    if (!window.confirm(TT.sureDeleteSalon)) return;

    try {
      const res = await fetch(`${API_BASE}/masacanli/salonlar/${salonId}`, {
        method: "DELETE",
        headers: authHeaders(),
      });

      const json = await res.json().catch(() => ({}));

      if (!res.ok || json?.ok === false) {
        throw new Error(json?.message || "Salon silinemedi");
      }

      setSelectedSalonId("all");
      notify(TT.deleted);
      loadLiveData();
    } catch (err) {
      console.error("Salon silme hatası:", err);
      notify(err.message || "Salon silinemedi", "error");
    }
  };

  const openAddTable = () => {
    const fallbackSalon =
      selectedSalonId !== "all" ? selectedSalonId : salons[0]?.id || "";

    setEditingTableId(null);
    setTableForm({
      salon_id: fallbackSalon,
      name: "",
      masa_no: "",
      capacity: 4,
      note: "",
    });

    setTableDialog(true);
  };

  const openEditTable = (table) => {
    setEditingTableId(table.id);
    setTableForm({
      salon_id: table.salon_id || "",
      name: table.name || table.masa_adi || "",
      masa_no: table.masa_no || table.name || table.masa_adi || "",
      capacity: table.capacity || table.kapasite || 4,
      note: table.note || table.notlar || "",
    });

    setTableDialog(true);
  };

  const saveTable = async () => {
    const cleanName = String(tableForm.name || "").trim();
    const cleanMasaNo = String(tableForm.masa_no || cleanName).trim();

    if (!tableForm.salon_id || !cleanName || !token) return;

    try {
      const url = editingTableId
        ? `${API_BASE}/masacanli/masalar/${editingTableId}`
        : `${API_BASE}/masacanli/masalar`;

      const res = await fetch(url, {
        method: editingTableId ? "PUT" : "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          salon_id: tableForm.salon_id,
          name: cleanName,
          masa_no: cleanMasaNo,
          capacity: Number(tableForm.capacity || 4),
          note: tableForm.note || "",
        }),
      });

      const json = await res.json().catch(() => ({}));

      if (!res.ok || json?.ok === false) {
        throw new Error(json?.message || "Masa kaydedilemedi");
      }

      setTableDialog(false);
      notify(editingTableId ? TT.statusUpdated : TT.saved);
      loadLiveData();
    } catch (err) {
      console.error("Masa kaydetme hatası:", err);
      notify(err.message || "Masa kaydedilemedi", "error");
    }
  };

  const deleteTable = async (tableId) => {
    if (!window.confirm(TT.sureDeleteTable)) return;

    try {
      const res = await fetch(`${API_BASE}/masacanli/masalar/${tableId}`, {
        method: "DELETE",
        headers: authHeaders(),
      });

      const json = await res.json().catch(() => ({}));

      if (!res.ok || json?.ok === false) {
        throw new Error(json?.message || "Masa silinemedi");
      }

      setSelectedTableId(null);
      notify(TT.deleted);
      loadLiveData();
    } catch (err) {
      console.error("Masa silme hatası:", err);
      notify(err.message || "Masa silinemedi", "error");
    }
  };

  const openAddGuest = (tableId) => {
    setSelectedTableId(tableId);
    setEditingGuestId(null);
    setGuestForm({ name: "", description: "" });
    setGuestDialog(true);
  };

  const openEditGuest = (guest) => {
    setEditingGuestId(guest.id);
    setGuestForm({
      name: guest.name || guest.kisi_adi || "",
      description: guest.description || guest.kisi_tanimi || "",
    });
    setGuestDialog(true);
  };

  const saveGuest = async () => {
    if (!selectedTableId || !token) return;

    const cleanName = String(guestForm.name || "").trim();

    if (!cleanName) return;

    try {
      const url = editingGuestId
        ? `${API_BASE}/masacanli/kisiler/${editingGuestId}`
        : `${API_BASE}/masacanli/kisiler`;

      const res = await fetch(url, {
        method: editingGuestId ? "PUT" : "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          table_id: selectedTableId,
          name: cleanName,
          description: guestForm.description || "",
        }),
      });

      const json = await res.json().catch(() => ({}));

      if (!res.ok || json?.ok === false) {
        throw new Error(json?.message || "Kişi kaydedilemedi");
      }

      setGuestDialog(false);
      notify(editingGuestId ? TT.statusUpdated : TT.saved);
      loadLiveData();
    } catch (err) {
      console.error("Kişi kaydetme hatası:", err);
      notify(err.message || "Kişi kaydedilemedi", "error");
    }
  };

  const deleteGuest = async (guestId) => {
    if (!window.confirm(TT.sureDeleteGuest)) return;

    try {
      const res = await fetch(`${API_BASE}/masacanli/kisiler/${guestId}`, {
        method: "DELETE",
        headers: authHeaders(),
      });

      const json = await res.json().catch(() => ({}));

      if (!res.ok || json?.ok === false) {
        throw new Error(json?.message || "Kişi silinemedi");
      }

      notify(TT.deleted);
      loadLiveData();
    } catch (err) {
      console.error("Kişi silme hatası:", err);
      notify(err.message || "Kişi silinemedi", "error");
    }
  };

  const markTableStatus = async (tableId, status) => {
    try {
      const res = await fetch(`${API_BASE}/masacanli/masalar/${tableId}/status`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify({
          status,
        }),
      });

      const json = await res.json().catch(() => ({}));

      if (!res.ok || json?.ok === false) {
        throw new Error(json?.message || "Masa durumu güncellenemedi");
      }

      notify(TT.statusUpdated);
      loadLiveData();
    } catch (err) {
      console.error("Masa durum hatası:", err);
      notify(err.message || "Masa durumu güncellenemedi", "error");
    }
  };

 const clearTable = async (tableId) => {
  if (!window.confirm(TT.sureClearTable)) return;

  try {
    const res = await fetch(`${API_BASE}/masacanli/masalar/${tableId}/clear`, {
      method: "PUT",
      headers: authHeaders(),
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json?.ok === false) {
      throw new Error(json?.message || "Masa boşaltılamadı");
    }

    setSelectedTableId(null);
    notify(TT.statusUpdated);
    loadLiveData();



  } catch (err) {
    console.error(
      "Masa boşaltma hatası:",
      err
    );

    notify(
      err.message ||
        "Masa boşaltılamadı",
      "error"
    );
  }
};

const openTableTransfer = (tableId) => {
  setTransferSourceTableId(tableId);
  setTransferTargetTableId("");
  setTransferDialog(true);
};

const completeTableTransfer = async () => {
  if (
    !transferSourceTableId ||
    !transferTargetTableId
  ) {
    notify(
      "Lütfen taşınacak hedef masayı seçin.",
      "warning"
    );

    return;
  }

  const targetTable = tables.find(
    (table) =>
      String(table.id) ===
      String(transferTargetTableId)
  );

  const sourceName =
    transferSourceTable?.name ||
    transferSourceTable?.masa_adi ||
    "Kaynak masa";

  const targetName =
    targetTable?.name ||
    targetTable?.masa_adi ||
    "hedef masa";

  const approved = window.confirm(
    `${sourceName} üzerindeki açık hesap, kişiler ve ödeme talepleri ${targetName} masasına taşınsın mı?`
  );

  if (!approved) return;

  setTransferLoading(true);

  try {
    const response = await fetch(
      `${API_BASE}/masacanli/masalar/${transferSourceTableId}/transfer`,
      {
        method: "POST",
        headers: authHeaders(),

        body: JSON.stringify({
          target_table_id: Number(
            transferTargetTableId
          ),
        }),
      }
    );

    const json = await response
      .json()
      .catch(() => ({}));

    if (
      !response.ok ||
      json?.ok === false
    ) {
      throw new Error(
        json?.message ||
          "Masa taşınamadı"
      );
    }

    setTransferDialog(false);
    setTransferSourceTableId(null);
    setTransferTargetTableId("");
    setSelectedTableId(null);

    notify(
      json?.message ||
        "Masa başarıyla taşındı."
    );

    await loadLiveData();
  } catch (err) {
    console.error(
      "Masa taşıma hatası:",
      err
    );

    notify(
      err?.message ||
        "Masa taşınamadı",
      "error"
    );
  } finally {
    setTransferLoading(false);
  }
};




const updatePaymentStatus = async (


requestId, status, paymentMethod = null) => {
  if (!token) {
    notify(TT.tokenMissing, "warning");
    return;
  }

  try {
    const res = await fetch(
      `${API_BASE}/masa-odeme-talepleri/${requestId}/status`,
      {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify({
          status,
          payment_method: paymentMethod,
        }),
      }
    );

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json?.ok === false) {
      throw new Error(json?.message || "İşlem tamamlanamadı");
    }

    notify(TT.statusUpdated);
    loadLiveData();
  } catch (err) {
    console.error("Ödeme durumu güncellenemedi:", err);
    notify(err.message || "İşlem tamamlanamadı", "error");
  }
};



const filteredStockItems = useMemo(() => {
  const q = String(manualSearch || "")
    .toLowerCase()
    .trim();

  return stockItems
    .filter((item) => {
      if (!q) return true;

      return String(
        item.title ||
        item.urun_adi ||
        ""
      )
        .toLowerCase()
        .includes(q);
    })
    .slice(0, 80);
}, [manualSearch, stockItems]);

const filteredMenuItems = useMemo(() => {
  const q = String(manualSearch || "")
    .toLocaleLowerCase("tr-TR")
    .trim();

  return menuCategories
    .filter(
      (category) =>
        selectedMenuCategoryId === "all" ||
        String(category.id) ===
          String(selectedMenuCategoryId)
    )
    .flatMap((category) =>
      category.items.map((item) => ({
        ...item,
        category_title: category.title,
      }))
    )
    .filter((item) => {
      if (!q) return true;

      return `${item.title || ""} ${
        item.category_title || ""
      }`
        .toLocaleLowerCase("tr-TR")
        .includes(q);
    })
    .slice(0, 160);
}, [
  manualSearch,
  menuCategories,
  selectedMenuCategoryId,
]);

const manualBasketTotal = useMemo(() => {


  return manualBasket.reduce((sum, item) => {
    return sum + Number(item.price || 0) * Number(item.quantity || 1);
  }, 0);
}, [manualBasket]);





const openManualOrder = (tableId) => {
  setSelectedTableId(tableId);
  setManualSearch("");
  setManualBasket([]);
  setManualNote("");
  setSelectedMenuCategoryId("all");

  setCustomItemForm({
    title: "",
    price: "",
    quantity: "1",
    currency: "TRY",
  });

  setManualDialog(true);

  Promise.all([
    fetchMenuCatalog(),
    fetchStockItems(),
  ]);
};

const getBasketItemKey = (item) =>
  String(
    item?.basket_key ||
    item?.id ||
    ""
  );

const basketAcceptsCurrency = (currency) => {
  const requestedCurrency =
    normalizeCurrency(currency || "TRY");

  const currentCurrency =
    manualBasket[0]?.currency
      ? normalizeCurrency(
          manualBasket[0].currency
        )
      : null;

  if (
    currentCurrency &&
    currentCurrency !== requestedCurrency
  ) {
    notify(
      `Sepette ${currentCurrency} ürün bulunuyor. Farklı para birimi aynı siparişe eklenemez.`,
      "warning"
    );

    return false;
  }

  return true;
};

const addMenuToBasket = (
  item,
  selectedOption = null
) => {
  const option = selectedOption || null;

  const price = option
    ? Number(option.price || 0)
    : Number(item.price || 0);

  const currency = normalizeCurrency(
    option?.currency ||
    item.currency ||
    "TRY"
  );

  const optionId = option?.id || null;
  const optionLabel = option?.label || "";

  const basketKey =
    `menu-${item.id}-${
      optionId || "base"
    }`;

  if (!basketAcceptsCurrency(currency)) {
    return;
  }

  setManualBasket((previous) => {
    const found = previous.find(
      (basketItem) =>
        getBasketItemKey(basketItem) ===
        basketKey
    );

    if (found) {
      return previous.map((basketItem) =>
        getBasketItemKey(basketItem) ===
        basketKey
          ? {
              ...basketItem,

              quantity:
                Number(
                  basketItem.quantity || 1
                ) + 1,
            }
          : basketItem
      );
    }

    return [
      ...previous,

      {
        basket_key: basketKey,

        id: item.id,

        menu_item_id: item.id,

        stock_item_id: null,

        item_source: "menu",

        source: "menu",

        category_id: item.category_id,

        category_title:
          item.category_title,

        title: item.title,

        display_title: optionLabel
          ? `${item.title} - ${optionLabel}`
          : item.title,

        option_id: optionId,

        option_label: optionLabel,

        price,

        quantity: 1,

        currency,

        is_custom: false,

        deduct_stock: true,
      },
    ];
  });
};

const addStockToBasket = (item) => {
  const currency = normalizeCurrency(
    item.currency || "TRY"
  );

  const basketKey = `stock-${item.id}`;

  if (!basketAcceptsCurrency(currency)) {
    return;
  }

  setManualBasket((prev) => {
    const found = prev.find(
      (itemInBasket) =>
        getBasketItemKey(itemInBasket) ===
        basketKey
    );

    if (found) {
      return prev.map((itemInBasket) =>
        getBasketItemKey(itemInBasket) ===
        basketKey
          ? {
              ...itemInBasket,

              quantity:
                Number(
                  itemInBasket.quantity || 1
                ) + 1,
            }
          : itemInBasket
      );
    }

    return [
      ...prev,

      {
        basket_key: basketKey,

        id: item.id,

        menu_item_id: null,

        stock_item_id: item.id,

        item_source: "stock",

        source: "stock",

        title:
          item.title ||
          item.urun_adi,

        display_title:
          item.title ||
          item.urun_adi,

        price: Number(item.price || 0),

        quantity: 1,

        currency,

        is_custom: false,

        deduct_stock: true,
      },
    ];
  });
};

const addCustomItemToBasket = () => {



  const title = String(
    customItemForm.title ||
    ""
  ).trim();

  const price = Number(
    String(
      customItemForm.price ||
      ""
    ).replace(",", ".")
  );

  const quantity = Math.max(
    1,
    Number(
      customItemForm.quantity ||
      1
    )
  );

  if (!title) {
    notify(
      "Özel ürün adı zorunludur.",
      "warning"
    );

    return;
  }

  if (
    !Number.isFinite(price) ||
    price <= 0
  ) {
    notify(
      "Özel ürün fiyatı sıfırdan büyük olmalıdır.",
      "warning"
    );

    return;
  }

   const customCurrency =
    normalizeCurrency(
      customItemForm.currency || "TRY"
    );

  if (
    !basketAcceptsCurrency(
      customCurrency
    )
  ) {
    return;
  }

  const customId =
    `custom-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 8)}`;

  setManualBasket(
    (previous) => [
      ...previous,

      {
        basket_key: customId,

        id: null,

        menu_item_id: null,

        stock_item_id: null,

        item_source: "custom",

        source: "custom",

        title,

        display_title: title,

        price,

        quantity,

        currency: customCurrency,

        is_custom: true,

        deduct_stock: false,
      },
    ]
  );

  setCustomItemForm({
    title: "",
    price: "",
    quantity: "1",

    currency:
      customItemForm.currency ||
      "TRY",
  });

  notify(
    "Özel ürün masa sepetine eklendi."
  );
};


const updateBasketQty = (id, qty) => {
  const n = Math.max(
    1,
    Number(qty || 1)
  );

  setManualBasket((prev) =>
    prev.map((x) =>
      getBasketItemKey(x) ===
      String(id)
        ? {
            ...x,
            quantity: n,
          }
        : x
    )
  );
};

const removeBasketItem = (id) => {
  setManualBasket((prev) =>
    prev.filter(
      (x) =>
        getBasketItemKey(x) !==
        String(id)
    )
  );
};





const completeManualOrder = async () => {
  if (
    !selectedTableId ||
    manualBasket.length === 0
  ) {
    notify(
      "Lütfen masa seçin ve sepete en az bir ürün ekleyin.",
      "warning"
    );

    return;
  }

  try {
    const customItemCount =
      manualBasket.filter(
        (item) =>
          item.item_source === "custom"
      ).length;

    const stockItemCount =
      manualBasket.filter(
        (item) =>
          item.item_source === "stock"
      ).length;

    const menuItemCount =
      manualBasket.filter(
        (item) =>
          item.item_source === "menu"
      ).length;

    const items = manualBasket.map(
      (item) => {
        const itemSource =
          item.item_source ||
          item.source ||
          "custom";

        const isCustom =
          itemSource === "custom";

        const quantity = Math.max(
          1,
          Number(item.quantity || 1)
        );

        const price = Math.max(
          0,
          Number(item.price || 0)
        );

        return {
          id: isCustom
            ? null
            : item.id,

          menu_item_id:
            itemSource === "menu"
              ? item.menu_item_id ||
                item.id
              : null,

          stock_item_id:
            itemSource === "stock"
              ? item.stock_item_id ||
                item.id
              : null,

          item_source: itemSource,

          source: itemSource,

          client_key: String(
            item.basket_key ||
              item.id ||
              `custom-${Date.now()}-${Math.random()}`
          ),

          title: String(
            item.title || ""
          ).trim(),

          price,

          quantity,

          currency:
            item.currency || "TRY",

          category_id:
            item.category_id || null,

          category_title:
            item.category_title || "",

          option_id:
            item.option_id || null,

          option_label:
            item.option_label || "",

          is_custom: isCustom,

          deduct_stock:
            itemSource !== "custom",
        };
      }
    );

    const emptyTitleItem = items.find(
      (item) => !item.title
    );

    if (emptyTitleItem) {
      notify(
        "Ürün adı boş bırakılamaz.",
        "error"
      );

      return;
    }

    const response = await fetch(
      `${API_BASE}/masacanli/masalar/${selectedTableId}/manual-order`,
      {
        method: "POST",

        headers: authHeaders(),

        body: JSON.stringify({
          menu_language: lang,

          note: String(
            manualNote || ""
          ).trim(),

          items,
        }),
      }
    );

    const json = await response
      .json()
      .catch(() => ({}));

    if (
      !response.ok ||
      json?.ok === false
    ) {
      throw new Error(
        json?.message ||
          "Ürünler masaya işlenemedi."
      );
    }

    setManualDialog(false);
    setManualBasket([]);
    setManualNote("");

    setCustomItemForm({
      title: "",
      price: "",
      quantity: "1",
      currency: "TRY",
    });

    const summaryParts = [];

    if (menuItemCount > 0) {
      summaryParts.push(
        `${menuItemCount} menü ürünü`
      );
    }

    if (stockItemCount > 0) {
      summaryParts.push(
        `${stockItemCount} stok ürünü`
      );
    }

    if (customItemCount > 0) {
      summaryParts.push(
        `${customItemCount} özel ürün`
      );
    }

    notify(
      `${summaryParts.join(
        ", "
      )} masanın adisyonuna eklendi.`
    );

    await loadLiveData();

    await Promise.all([
      fetchMenuCatalog(),
      fetchStockItems(),
    ]);
  } catch (err) {
    console.error(
      "Manuel masa siparişi hatası:",
      err
    );

    notify(
      err?.message ||
        "Ürünler masaya işlenemedi.",
      "error"
    );

    await loadLiveData();
  }
};


  const copyQrLink = async (table) => {

    const salon = salons.find((s) => String(s.id) === String(table.salon_id));
    const kurumCode =
      localStorage.getItem("kurum_code") ||
      localStorage.getItem("kurumKodu") ||
      localStorage.getItem("app_kurum_code") ||
      "KURUM_KODU";

    const tableName = table.masa_no || table.name || table.masa_adi || "";
    const salonName = salon?.name || salon?.salon_adi || "";

    const url = `${window.location.origin}/#/menu/${kurumCode}?masa=${encodeURIComponent(
      tableName
    )}&salon=${encodeURIComponent(salonName)}`;

    try {
      await navigator.clipboard.writeText(url);
      notify(TT.copied);
    } catch {
      window.prompt("QR linki:", url);
    }
  };

  const statCards = [
    {
      title: TT.totalTables,
      value: summary.totalTables,
      icon: <EventSeatIcon />,
      bg: BRAND.softBlue,
      color: BRAND.blue,
    },
    {
      title: TT.activeTables,
      value: summary.activeTables,
      icon: <GroupsIcon />,
      bg: BRAND.softOrange,
      color: BRAND.orange,
    },
    {
      title: TT.paymentWaiting,
      value: summary.paymentWaiting,
      icon: <PaymentIcon />,
      bg: alpha(theme.palette.error.main, 0.08),
      color: theme.palette.error.main,
    },
    {
      title: TT.totalRevenue,
      value: moneyText(summary.totalRevenue, "TRY", lang),
      icon: <PointOfSaleIcon />,
      bg: alpha(theme.palette.success.main, 0.08),
      color: theme.palette.success.main,
    },
  ];

  const renderLiveBoard = () => (
    <>
      <Card
        sx={{
          borderRadius: 4,
          mb: 2,
          border: `1px solid ${alpha(BRAND.blue, 0.12)}`,
          boxShadow: "0 14px 38px rgba(15,23,42,0.06)",
        }}
      >
        <CardContent sx={{ p: { xs: 1.5, md: 2 } }}>
          <Stack spacing={1.5}>
            <Stack
              direction={{ xs: "column", md: "row" }}
              alignItems={{ xs: "stretch", md: "center" }}
              justifyContent="space-between"
              spacing={1.5}
            >
              <TextField
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={TT.search}
                size="small"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  maxWidth: { md: 520 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 3,
                    bgcolor: "#fff",
                    fontWeight: 800,
                  },
                }}
              />

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1}
                sx={{
                  "& .MuiButton-root": {
                    minHeight: 46,
                    borderRadius: 3,
                    textTransform: "none",
                    fontWeight: 950,
                  },
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={openAddSalon}
                  sx={{
                    bgcolor: BRAND.blue,
                    "&:hover": { bgcolor: "#1d4ed8" },
                  }}
                >
                  {TT.addSalon}
                </Button>

                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={openAddTable}
                  sx={{
                    bgcolor: BRAND.orange,
                    "&:hover": { bgcolor: BRAND.orangeDark },
                  }}
                >
                  {TT.addTable}
                </Button>
              </Stack>
            </Stack>

            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                overflowX: "auto",
                pb: 0.4,
                "&::-webkit-scrollbar": { height: 6 },
                "&::-webkit-scrollbar-thumb": {
                  bgcolor: alpha(BRAND.blueDark, 0.22),
                  borderRadius: 99,
                },
              }}
            >
              <ToggleButtonGroup
                exclusive
                value={selectedSalonId}
                onChange={(e, value) => {
                  if (value) setSelectedSalonId(value);
                }}
                sx={{
                  minWidth: "max-content",
                  "& .MuiToggleButton-root": {
                    borderRadius: "14px !important",
                    mr: 1,
                    px: 1.6,
                    py: 0.8,
                    border: `1px solid ${alpha(BRAND.blue, 0.12)}`,
                    textTransform: "none",
                    fontWeight: 900,
                  },
                  "& .Mui-selected": {
                    bgcolor: `${BRAND.softBlue} !important`,
                    color: `${BRAND.blue} !important`,
                    borderColor: `${alpha(BRAND.blue, 0.32)} !important`,
                  },
                }}
              >
                <ToggleButton value="all">{TT.allSalons}</ToggleButton>

                {salons.map((salon) => (
                  <ToggleButton key={salon.id} value={salon.id}>
                    {salon.name || salon.salon_adi}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Box>

            {selectedSalonId !== "all" && (
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1}
                sx={{
                  "& .MuiButton-root": {
                    borderRadius: 3,
                    textTransform: "none",
                    fontWeight: 900,
                  },
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<EditIcon />}
                  onClick={() => {
                    const salon = salons.find(
                      (s) => String(s.id) === String(selectedSalonId)
                    );
                    if (salon) openEditSalon(salon);
                  }}
                >
                  {TT.editSalon}
                </Button>

                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<DeleteIcon />}
                  onClick={() => deleteSalon(selectedSalonId)}
                >
                  {TT.delete}
                </Button>
              </Stack>
            )}
          </Stack>
        </CardContent>
      </Card>

      <Alert
        severity="info"
        sx={{
          mb: 2,
          borderRadius: 3,
          border: `1px solid ${alpha(BRAND.blue, 0.14)}`,
          "& .MuiAlert-message": { fontWeight: 750 },
        }}
      >
        {TT.dbConnected} · {TT.liveRefresh} · {TT.deleteInfo}
      </Alert>

      {filteredTables.length === 0 ? (
        <Alert severity="warning" sx={{ borderRadius: 3 }}>
          {TT.noTables}
        </Alert>
      ) : (


<Box
  sx={{
    width: "100%",
    minWidth: 0,

    display: "grid",

    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(2, minmax(0, 1fr))",
      lg: "repeat(3, minmax(0, 1fr))",
      xl: "repeat(3, minmax(0, 1fr))",
    },

    gap: {
      xs: 2,
      sm: 2.25,
      md: 2.75,
      xl: 3,
    },

    alignItems: "stretch",
  }}
>


          {filteredTables.map((table, index) => {
            const salon = salons.find(
              (s) => String(s.id) === String(table.salon_id)
            );
            const stat = tableStatsMap[table.id];
            const status = getStatusConfig(stat?.status, TT, theme);

            return (
             <Card
  key={table.id}

  onClick={() =>
    setSelectedTableId(
      table.id
    )
  }

  sx={{
    position: "relative",

    display: "flex",
    flexDirection: "column",

 width: "100%",
minWidth: 0,
height: "100%",

minHeight: {
  xs: 390,
  sm: 410,
  md: 425,
},

    overflow: "hidden",

    cursor: "pointer",

    borderRadius: {
      xs: 4,
      md: 5,
    },

    border:
      `1px solid ${alpha(
        status.color,
        0.18
      )}`,

    background:
      `linear-gradient(
        155deg,
        #FFFFFF 0%,
        #FFFFFF 62%,
        ${status.bg} 100%
      )`,

    boxShadow:
      "0 18px 50px rgba(15, 23, 42, 0.08)",

    transition:
      "transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease",

    animation:
      "masaFade .35s ease both",

    animationDelay:
      `${Math.min(
        index * 0.025,
        0.35
      )}s`,

    "&:hover": {
      transform: {
        xs: "none",
        md: "translateY(-6px)",
      },

      borderColor:
        alpha(
          status.color,
          0.38
        ),

      boxShadow:
        "0 28px 70px rgba(15, 23, 42, 0.14)",
    },
  }}
>


               <Box
  sx={{
    height: 5,

    flexShrink: 0,

    background:
      `linear-gradient(
        90deg,
        ${
          salon?.color ||
          salon?.renk ||
          BRAND.blue
        },
        ${status.color}
      )`,

    boxShadow:
      `0 3px 12px ${alpha(
        status.color,
        0.22
      )}`,
  }}
/>

<CardContent
  sx={{
    flex: 1,

    display: "flex",
    flexDirection: "column",

    padding: {
      xs: "18px !important",
      sm: "20px !important",
      md: "22px !important",
    },
  }}
>
  <Stack
    spacing={1.55}
    sx={{
      flex: 1,
      minWidth: 0,
    }}
  >


<Stack
  direction="row"
  justifyContent="space-between"
  alignItems="flex-start"
  spacing={1.25}
  sx={{
    minHeight: 58,
  }}
>
  <Box
    sx={{
      flex: 1,
      minWidth: 0,
      paddingRight: 0.5,
    }}
  >
    <Typography
      title={
        table.name ||
        table.masa_adi ||
        ""
      }
      sx={{
        color: BRAND.blueDark,

        fontSize: {
          xs: 20,
          md: 22,
        },

        fontWeight: 950,
        lineHeight: 1.15,
        letterSpacing: -0.25,

        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {table.name ||
        table.masa_adi}
    </Typography>

    <Typography
      sx={{
        marginTop: 0.65,

        color: "text.secondary",

        fontSize: 12.5,
        fontWeight: 800,
        lineHeight: 1.35,

        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {salon?.name ||
        salon?.salon_adi ||
        "-"}

      {" · "}

      {table.capacity ||
        table.kapasite ||
        0}

      {" kişi"}
    </Typography>
  </Box>

  <Chip
    size="small"
    label={`${status.icon} ${status.label}`}
    color={status.chip}
    sx={{
      flexShrink: 0,
      minHeight: 27,
      borderRadius: 99,
      fontWeight: 950,

      "& .MuiChip-label": {
        paddingX: 1.15,
      },
    }}
  />
</Stack>

                 <Box
  sx={{
    p: {
      xs: 1.25,
      md: 1.5,
    },

    borderRadius: 3.5,

    background:
      `linear-gradient(
        135deg,
        #F8FAFC 0%,
        ${status.bg} 100%
      )`,

    border:
      `1px solid ${alpha(
        status.color,
        0.16
      )}`,

    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,0.80)",
  }}
>



  <Box
    sx={{
      display: "grid",

      gridTemplateColumns:
        "repeat(3, minmax(0, 1fr))",

      gap: 0,

      "& > div": {
        minWidth: 0,

        paddingX: {
          xs: 0.75,
          md: 1.15,
        },
      },

      "& > div:first-of-type": {
        paddingLeft: 0,
      },

      "& > div:last-of-type": {
        paddingRight: 0,
      },

      "& > div:not(:last-of-type)": {
        borderRight:
          "1px solid rgba(15, 23, 42, 0.09)",
      },
    }}
  >


                        <Box>
                          <Typography variant="caption" color="text.secondary">
                            {TT.total}
                          </Typography>
                          <Typography sx={{ fontWeight: 950, fontSize: 13 }}>
                            {moneyText(stat?.total, stat?.currency, lang)}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography variant="caption" color="text.secondary">
                            {TT.paid}
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 950,
                              fontSize: 13,
                              color: theme.palette.success.main,
                            }}
                          >
                            {moneyText(stat?.paid, stat?.currency, lang)}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography variant="caption" color="text.secondary">
                            {TT.remaining}
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 950,
                              fontSize: 13,
                              color:
                                safeNumber(stat?.remaining) > 0
                                  ? BRAND.orange
                                  : theme.palette.success.main,
                            }}
                          >
                            {moneyText(stat?.remaining, stat?.currency, lang)}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                 


<Box
  sx={{
    display: "grid",

    gridTemplateColumns:
      "repeat(3, minmax(0, 1fr))",

    gap: 0.8,
  }}
>
  {[
    {
      key: "guests",

      icon: (
        <GroupsIcon
          sx={{ fontSize: 18 }}
        />
      ),

      value:
        stat?.guests?.length || 0,

      label: TT.guests,
    },

    {
      key: "orders",

      icon: (
        <PointOfSaleIcon
          sx={{ fontSize: 18 }}
        />
      ),

      value:
        stat?.orders?.length || 0,

      label: TT.orders,
    },

    {
      key: "payments",

      icon: (
        <PaymentIcon
          sx={{ fontSize: 18 }}
        />
      ),

      value:
        stat?.pendingPayments
          ?.length || 0,

      label:
        TT.paymentRequests,

      danger:
        stat?.pendingPayments
          ?.length > 0,
    },
  ].map((metric) => (
    <Box
      key={metric.key}
      sx={{
        minWidth: 0,
        minHeight: 58,

        padding: "7px 5px",

        borderRadius: 2.75,

        display: "flex",
        flexDirection: "column",

        alignItems: "center",
        justifyContent: "center",

        textAlign: "center",

        color:
          metric.danger
            ? theme.palette.error.main
            : BRAND.blueDark,

        backgroundColor:
          metric.danger
            ? alpha(
                theme.palette.error.main,
                0.06
              )
            : "#F8FAFC",

        border:
          `1px solid ${
            metric.danger
              ? alpha(
                  theme.palette.error.main,
                  0.18
                )
              : "rgba(15, 23, 42, 0.08)"
          }`,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={0.45}
      >
        {metric.icon}

        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 950,
          }}
        >
          {metric.value}
        </Typography>
      </Stack>

      <Typography
        sx={{
          width: "100%",
          marginTop: 0.3,

          fontSize: 10.5,
          fontWeight: 850,
          lineHeight: 1.1,

          overflow: "hidden",

          display:
            "-webkit-box",

          WebkitLineClamp: 2,

          WebkitBoxOrient:
            "vertical",
        }}
      >
        {metric.label}
      </Typography>
    </Box>
  ))}
</Box>

                 <Box
  sx={{
    minHeight: 46,

    padding: "9px 11px",

    borderRadius: 2.5,

    color: "text.secondary",

    backgroundColor: "#F8FAFC",

    border:
      "1px solid #E2E8F0",

    fontSize: 11.5,
    fontWeight: 750,
    lineHeight: 1.35,

    overflow: "hidden",

    display: "-webkit-box",

    WebkitLineClamp: 2,

    WebkitBoxOrient:
      "vertical",

    visibility:
      table.note ||
      table.notlar
        ? "visible"
        : "hidden",
  }}
>
  {table.note ||
    table.notlar ||
    "\u00A0"}
</Box>


<Box
  onClick={(event) =>
    event.stopPropagation()
  }
  sx={{
    marginTop: "auto",
    paddingTop: 0.4,

    display: "grid",

    gridTemplateColumns: {
      xs: "1fr",

      sm:
        "repeat(2, minmax(0, 1fr))",

      lg:
        "repeat(3, minmax(0, 1fr))",
    },

    gap: 1,

    "& .MuiButton-root": {
      width: "100%",
      minWidth: 0,
      minHeight: 54,

      paddingX: 0.9,
      paddingY: 0.8,

      borderRadius: 3,

      textTransform: "none",

      fontSize: {
        xs: 13,
        md: 13.5,
      },

      fontWeight: 950,
      lineHeight: 1.15,

      whiteSpace: "normal",

      textAlign: "center",

      transition:
        "transform 180ms ease, box-shadow 180ms ease, background-color 180ms ease",

      "&:hover": {
        transform:
          "translateY(-2px)",
      },

      "& .MuiButton-startIcon": {
        marginLeft: 0,
        marginRight: 0.55,
      },
    },

    "& > .MuiButton-root:first-of-type": {
      gridColumn: {
        xs: "auto",
        sm: "1 / -1",
        lg: "auto",
      },
    },
  }}
>


  <Button
    variant="contained"

    startIcon={
      <PointOfSaleIcon />
    }

    onClick={() =>
      setSelectedTableId(
        table.id
      )
    }

    sx={{
      color: "#FFFFFF",

      bgcolor:
        BRAND.blue,

      boxShadow:
        "0 10px 24px rgba(37, 99, 235, 0.24)",

      "&:hover": {
        bgcolor:
          "#1D4ED8",

        boxShadow:
          "0 14px 30px rgba(37, 99, 235, 0.32)",
      },
    }}
  >
    {TT.openBill}
  </Button>

  <Button
    variant="outlined"

    startIcon={
      <PersonAddIcon />
    }

    onClick={() =>
      openAddGuest(
        table.id
      )
    }

    sx={{
      color:
        BRAND.orangeDark,

      borderColor:
        alpha(
          BRAND.orange,
          0.38
        ),

      bgcolor:
        alpha(
          BRAND.orange,
          0.035
        ),

      "&:hover": {
        borderColor:
          BRAND.orange,

        bgcolor:
          BRAND.softOrange,
      },
    }}
  >
    {TT.addGuest}
  </Button>

  <Button
    variant="outlined"

    startIcon={
      <AddShoppingCartIcon />
    }

    onClick={() =>
      openManualOrder(
        table.id
      )
    }

    sx={{
      color:
        BRAND.blue,

      borderColor:
        alpha(
          BRAND.blue,
          0.32
        ),

      bgcolor:
        alpha(
          BRAND.blue,
          0.035
        ),

      "&:hover": {
        borderColor:
          BRAND.blue,

        bgcolor:
          BRAND.softBlue,
      },
    }}
  >
    Manuel Ürün
  </Button>
</Box>

                  </Stack>
                </CardContent>
              </Card>
            );
          })}
        </Box>
      )}
    </>
  );



const renderReports = () => {
  const R =
    {
      tr: {
        reportCenter: "Profesyonel Rapor Merkezi",
        reportDesc:
          "Masa performansı, ürün satışları, tahsilat ve bekleyen tutarları işletme raporu formatında takip edin.",
        tableReport: "Masa Performans Raporu",
        productReport: "Ürün Satış Raporu",
        table: "Masa",
        salon: "Salon",
        order: "Sipariş",
        revenue: "Ciro",
        paid: "Ödenen",
        pending: "Bekleyen",
        remaining: "Kalan",
        performance: "Performans",
        product: "Ürün",
        qty: "Adet",
        avg: "Ortalama",
        share: "Pay",
        totalRevenue: "Toplam Ciro",
        totalPaid: "Toplam Tahsilat",
        totalPending: "Bekleyen Ödeme",
        totalRemaining: "Açık Kalan",
        noData: "Rapor oluşturmak için henüz yeterli sipariş verisi yok.",
      },
      en: {
        reportCenter: "Professional Report Center",
        reportDesc:
          "Track table performance, product sales, collections and pending amounts in business report format.",
        tableReport: "Table Performance Report",
        productReport: "Product Sales Report",
        table: "Table",
        salon: "Hall",
        order: "Order",
        revenue: "Revenue",
        paid: "Paid",
        pending: "Pending",
        remaining: "Remaining",
        performance: "Performance",
        product: "Product",
        qty: "Qty",
        avg: "Average",
        share: "Share",
        totalRevenue: "Total Revenue",
        totalPaid: "Total Paid",
        totalPending: "Pending Payment",
        totalRemaining: "Remaining",
        noData: "There is not enough order data to generate reports yet.",
      },
      de: {
        reportCenter: "Professionelles Berichtszentrum",
        reportDesc:
          "Tischleistung, Produktverkäufe, Zahlungen und offene Beträge im Geschäftsbericht verfolgen.",
        tableReport: "Tisch-Leistungsbericht",
        productReport: "Produktverkaufsbericht",
        table: "Tisch",
        salon: "Saal",
        order: "Bestellung",
        revenue: "Umsatz",
        paid: "Bezahlt",
        pending: "Offen",
        remaining: "Restbetrag",
        performance: "Leistung",
        product: "Produkt",
        qty: "Menge",
        avg: "Durchschnitt",
        share: "Anteil",
        totalRevenue: "Gesamtumsatz",
        totalPaid: "Gesamt bezahlt",
        totalPending: "Offene Zahlung",
        totalRemaining: "Restbetrag",
        noData: "Es gibt noch nicht genug Bestelldaten für Berichte.",
      },
    }[lang] || {};

  const tableRows = reports.tableRows || [];
  const productRows = reports.productRows || [];

  const totalRevenue = tableRows.reduce(
    (sum, row) => sum + safeNumber(row.revenue),
    0
  );

  const totalPaid = tableRows.reduce(
    (sum, row) => sum + safeNumber(row.paid),
    0
  );

  const totalPending = tableRows.reduce(
    (sum, row) => sum + safeNumber(row.pending),
    0
  );

  const totalRemaining = tableRows.reduce((sum, row) => {
    const remaining = Math.max(
      safeNumber(row.revenue) - safeNumber(row.paid),
      0
    );
    return sum + remaining;
  }, 0);

  const maxTableRevenue = Math.max(
    ...tableRows.map((row) => safeNumber(row.revenue)),
    0
  );

  const maxProductRevenue = Math.max(
    ...productRows.map((row) => safeNumber(row.revenue)),
    0
  );

  const reportCards = [
    {
      title: R.totalRevenue,
      value: moneyText(totalRevenue, "TRY", lang),
      color: BRAND.blue,
      bg: BRAND.softBlue,
      icon: "📊",
    },
    {
      title: R.totalPaid,
      value: moneyText(totalPaid, "TRY", lang),
      color: BRAND.green,
      bg: alpha(BRAND.green, 0.08),
      icon: "✅",
    },
    {
      title: R.totalPending,
      value: moneyText(totalPending, "TRY", lang),
      color: BRAND.orange,
      bg: BRAND.softOrange,
      icon: "⏳",
    },
    {
      title: R.totalRemaining,
      value: moneyText(totalRemaining, "TRY", lang),
      color: BRAND.red,
      bg: alpha(BRAND.red, 0.08),
      icon: "⚠️",
    },
  ];

  return (
    <Stack spacing={2}>
      <Card
        sx={{
          borderRadius: 5,
          overflow: "hidden",
          boxShadow: "0 24px 70px rgba(15,23,42,0.10)",
          border: `1px solid ${alpha(BRAND.blue, 0.12)}`,
          background:
            "linear-gradient(135deg, #0f172a 0%, #1d4ed8 48%, #f97316 130%)",
          color: "#fff",
        }}
      >
        <CardContent sx={{ p: { xs: 2, md: 3 } }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", md: "center" }}
            spacing={2}
          >
            <Box>
              <Typography
                variant="overline"
                sx={{
                  fontWeight: 950,
                  letterSpacing: 1.1,
                  opacity: 0.82,
                }}
              >
                MESYAT DIGITAL · REPORT
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  fontWeight: 950,
                  mt: 0.5,
                  fontSize: { xs: 24, md: 34 },
                }}
              >
                {R.reportCenter}
              </Typography>

              <Typography
                sx={{
                  mt: 1,
                  maxWidth: 760,
                  opacity: 0.88,
                  fontWeight: 650,
                  lineHeight: 1.55,
                }}
              >
                {R.reportDesc}
              </Typography>
            </Box>

            <Box
              sx={{
                width: { xs: "100%", md: 170 },
                height: 110,
                borderRadius: 4,
                bgcolor: "rgba(255,255,255,.14)",
                border: "1px solid rgba(255,255,255,.22)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 54,
              }}
            >
              📈
            </Box>
          </Stack>
        </CardContent>
      </Card>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0,1fr))",
            lg: "repeat(4, minmax(0,1fr))",
          },
          gap: 1.5,
        }}
      >
        {reportCards.map((card) => (
          <Card
            key={card.title}
            sx={{
              borderRadius: 4,
              border: `1px solid ${alpha(card.color, 0.16)}`,
              boxShadow: "0 14px 38px rgba(15,23,42,0.07)",
              overflow: "hidden",
            }}
          >
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Box
                  sx={{
                    width: 54,
                    height: 54,
                    borderRadius: 3,
                    bgcolor: card.bg,
                    color: card.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 28,
                  }}
                >
                  {card.icon}
                </Box>

                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "text.secondary",
                      fontWeight: 850,
                    }}
                  >
                    {card.title}
                  </Typography>

                  <Typography
                    variant="h6"
                    sx={{
                      color: card.color,
                      fontWeight: 950,
                      lineHeight: 1.15,
                      wordBreak: "break-word",
                    }}
                  >
                    {card.value}
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Box>

      <Card
        sx={{
          borderRadius: 4,
          boxShadow: "0 18px 45px rgba(15,23,42,.08)",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            p: { xs: 1.6, md: 2.2 },
            borderBottom: "1px solid #e2e8f0",
            background:
              "linear-gradient(90deg, rgba(37,99,235,.10), rgba(249,115,22,.08))",
          }}
        >
          <Stack direction="row" spacing={1.2} alignItems="center">
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: 3,
                bgcolor: BRAND.softBlue,
                color: BRAND.blue,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 25,
              }}
            >
              🪑
            </Box>

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 950 }}>
                {R.tableReport}
              </Typography>

              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontWeight: 750 }}
              >
                {TT.bestTables}
              </Typography>
            </Box>
          </Stack>
        </Box>

        {tableRows.length === 0 ? (
          <CardContent>
            <Alert severity="info" sx={{ borderRadius: 3 }}>
              {R.noData}
            </Alert>
          </CardContent>
        ) : (
          <Box sx={{ overflowX: "auto" }}>
            <Box sx={{ minWidth: 980 }}>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns:
                    "70px 1.4fr 1.2fr 90px 150px 150px 150px 150px 190px",
                  gap: 1,
                  px: 2,
                  py: 1.3,
                  bgcolor: "#f8fafc",
                  borderBottom: "1px solid #e2e8f0",
                }}
              >
                {[
                  "#",
                  R.table,
                  R.salon,
                  R.order,
                  R.revenue,
                  R.paid,
                  R.pending,
                  R.remaining,
                  R.performance,
                ].map((head) => (
                  <Typography
                    key={head}
                    variant="caption"
                    sx={{
                      fontWeight: 950,
                      color: "#334155",
                      textTransform: "uppercase",
                      letterSpacing: 0.4,
                    }}
                  >
                    {head}
                  </Typography>
                ))}
              </Box>

              {tableRows.slice(0, 30).map((row, index) => {
                const remaining = Math.max(
                  safeNumber(row.revenue) - safeNumber(row.paid),
                  0
                );

                const performance =
                  maxTableRevenue > 0
                    ? Math.min(
                        (safeNumber(row.revenue) / maxTableRevenue) * 100,
                        100
                      )
                    : 0;

                return (
                  <Box
                    key={row.id || row.name}
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "70px 1.4fr 1.2fr 90px 150px 150px 150px 150px 190px",
                      gap: 1,
                      px: 2,
                      py: 1.35,
                      alignItems: "center",
                      borderBottom: "1px solid #eef2f7",
                      bgcolor: index % 2 === 0 ? "#fff" : "#f8fafc",
                      "&:hover": {
                        bgcolor: BRAND.softBlue,
                      },
                    }}
                  >
                    <Chip
                      size="small"
                      label={index + 1}
                      sx={{
                        width: 42,
                        fontWeight: 950,
                        bgcolor:
                          index === 0
                            ? BRAND.softOrange
                            : alpha(BRAND.blue, 0.08),
                        color: index === 0 ? BRAND.orangeDark : BRAND.blue,
                      }}
                    />

                    <Typography sx={{ fontWeight: 950, color: BRAND.blueDark }}>
                      {row.name}
                    </Typography>

                    <Typography sx={{ fontWeight: 750, color: "#64748b" }}>
                      {row.salonName || "-"}
                    </Typography>

                    <Typography sx={{ fontWeight: 900 }}>
                      {row.orders || 0}
                    </Typography>

                    <Typography sx={{ fontWeight: 950, color: BRAND.blue }}>
                      {moneyText(row.revenue, row.currency, lang)}
                    </Typography>

                    <Typography sx={{ fontWeight: 950, color: BRAND.green }}>
                      {moneyText(row.paid, row.currency, lang)}
                    </Typography>

                    <Typography sx={{ fontWeight: 950, color: BRAND.orange }}>
                      {moneyText(row.pending, row.currency, lang)}
                    </Typography>

                    <Typography sx={{ fontWeight: 950, color: BRAND.red }}>
                      {moneyText(remaining, row.currency, lang)}
                    </Typography>




                    <Box>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        spacing={1}
                        sx={{ mb: 0.5 }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ fontWeight: 900, color: "#64748b" }}
                        >
                          %{Math.round(performance)}
                        </Typography>

                        {index === 0 && (
                          <Chip
                            size="small"
                            label="TOP"
                            sx={{
                              height: 20,
                              fontWeight: 950,
                              bgcolor: BRAND.softOrange,
                              color: BRAND.orangeDark,
                            }}
                          />
                        )}
                      </Stack>

                      <LinearProgress
                        variant="determinate"
                        value={performance}
                        sx={{
                          height: 9,
                          borderRadius: 99,
                          bgcolor: alpha(BRAND.blue, 0.1),
                          "& .MuiLinearProgress-bar": {
                            borderRadius: 99,
                            background: `linear-gradient(90deg, ${BRAND.blue}, ${BRAND.orange})`,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}
      </Card>

      <Card
        sx={{
          borderRadius: 4,
          boxShadow: "0 18px 45px rgba(15,23,42,.08)",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            p: { xs: 1.6, md: 2.2 },
            borderBottom: "1px solid #e2e8f0",
            background:
              "linear-gradient(90deg, rgba(249,115,22,.10), rgba(37,99,235,.08))",
          }}
        >
          <Stack direction="row" spacing={1.2} alignItems="center">
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: 3,
                bgcolor: BRAND.softOrange,
                color: BRAND.orange,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 25,
              }}
            >
              🍽️
            </Box>

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 950 }}>
                {R.productReport}
              </Typography>

              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontWeight: 750 }}
              >
                {TT.bestProducts}
              </Typography>
            </Box>
          </Stack>
        </Box>

        {productRows.length === 0 ? (
          <CardContent>
            <Alert severity="info" sx={{ borderRadius: 3 }}>
              {R.noData}
            </Alert>
          </CardContent>
        ) : (
          <Box sx={{ overflowX: "auto" }}>
            <Box sx={{ minWidth: 760 }}>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "70px 1.8fr 120px 160px 160px 210px",
                  gap: 1,
                  px: 2,
                  py: 1.3,
                  bgcolor: "#f8fafc",
                  borderBottom: "1px solid #e2e8f0",
                }}
              >
                {["#", R.product, R.qty, R.revenue, R.avg, R.share].map(
                  (head) => (
                    <Typography
                      key={head}
                      variant="caption"
                      sx={{
                        fontWeight: 950,
                        color: "#334155",
                        textTransform: "uppercase",
                        letterSpacing: 0.4,
                      }}
                    >
                      {head}
                    </Typography>
                  )
                )}
              </Box>

              {productRows.slice(0, 40).map((row, index) => {
                const share =
                  maxProductRevenue > 0
                    ? Math.min(
                        (safeNumber(row.revenue) / maxProductRevenue) * 100,
                        100
                      )
                    : 0;

                const avg =
                  safeNumber(row.qty) > 0
                    ? safeNumber(row.revenue) / safeNumber(row.qty)
                    : 0;

                return (
                  <Box
                    key={row.title}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "70px 1.8fr 120px 160px 160px 210px",
                      gap: 1,
                      px: 2,
                      py: 1.35,
                      alignItems: "center",
                      borderBottom: "1px solid #eef2f7",
                      bgcolor: index % 2 === 0 ? "#fff" : "#f8fafc",
                      "&:hover": {
                        bgcolor: BRAND.softOrange,
                      },
                    }}
                  >
                    <Chip
                      size="small"
                      label={index + 1}
                      sx={{
                        width: 42,
                        fontWeight: 950,
                        bgcolor:
                          index === 0
                            ? BRAND.softOrange
                            : alpha(BRAND.orange, 0.08),
                        color:
                          index === 0 ? BRAND.orangeDark : BRAND.orange,
                      }}
                    />

                    <Typography sx={{ fontWeight: 950, color: BRAND.blueDark }}>
                      {row.title}
                    </Typography>

                    <Typography sx={{ fontWeight: 900 }}>
                      {row.qty}
                    </Typography>

                    <Typography sx={{ fontWeight: 950, color: BRAND.orange }}>
                      {moneyText(row.revenue, row.currency, lang)}
                    </Typography>

                    <Typography sx={{ fontWeight: 900, color: "#334155" }}>
                      {moneyText(avg, row.currency, lang)}
                    </Typography>

                    <Box>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        spacing={1}
                        sx={{ mb: 0.5 }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ fontWeight: 900, color: "#64748b" }}
                        >
                          %{Math.round(share)}
                        </Typography>

                        {index === 0 && (
                          <Chip
                            size="small"
                            label="BEST"
                            sx={{
                              height: 20,
                              fontWeight: 950,
                              bgcolor: BRAND.softBlue,
                              color: BRAND.blue,
                            }}
                          />
                        )}
                      </Stack>

                      <LinearProgress
                        variant="determinate"
                        value={share}
                        sx={{
                          height: 9,
                          borderRadius: 99,
                          bgcolor: alpha(BRAND.orange, 0.12),
                          "& .MuiLinearProgress-bar": {
                            borderRadius: 99,
                            background: `linear-gradient(90deg, ${BRAND.orange}, ${BRAND.blue})`,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}
      </Card>
    </Stack>
  );
};
  const renderTraining = () => (
    <Card sx={{ borderRadius: 4, boxShadow: "0 18px 45px rgba(15,23,42,.08)" }}>
      <CardContent sx={{ p: { xs: 1.6, md: 2.4 } }}>
        <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 2 }}>
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: 3,
              bgcolor: BRAND.softBlue,
              color: BRAND.blue,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SchoolIcon />
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" sx={{ fontWeight: 950 }}>
              {TT.educationTitle}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 750 }}>
              {TT.educationSubtitle}
            </Typography>
          </Box>
        </Stack>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" },
            gap: 1.4,
          }}
        >
          {(TRAINING[lang] || TRAINING.tr).map((item, index) => (
            <Box
              key={item.title}
              sx={{
                p: 1.5,
                borderRadius: 3,
                bgcolor: index % 2 === 0 ? BRAND.softBlue : BRAND.softOrange,
                border: `1px solid ${
                  index % 2 === 0 ? alpha(BRAND.blue, 0.18) : alpha(BRAND.orange, 0.2)
                }`,
                animation: "masaFade .35s ease both",
                animationDelay: `${index * 0.04}s`,
              }}
            >
              <Typography sx={{ fontWeight: 950, color: BRAND.blueDark, mb: 0.8 }}>
                {item.title}
              </Typography>
              <Typography sx={{ fontWeight: 700, color: "#475569", lineHeight: 1.6 }}>
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        bgcolor: "#f6f8fb",
        p: { xs: 1.2, sm: 2, md: 3 },
      }}
    >
      <style>
        {`
          @keyframes masaFade {
            from {
              opacity: 0;
              transform: translateY(10px) scale(.985);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }

          @keyframes masaGlow {
            0% { box-shadow: 0 0 0 0 rgba(249, 115, 22, .26); }
            70% { box-shadow: 0 0 0 12px rgba(249, 115, 22, 0); }
            100% { box-shadow: 0 0 0 0 rgba(249, 115, 22, 0); }
          }
        `}
      </style>

      <Box
        sx={{
          width: "100%",
          maxWidth: 1480,
          mx: "auto",
          minWidth: 0,
        }}
      >
        <Card
          sx={{
            borderRadius: { xs: 3, md: 5 },
            overflow: "hidden",
            mb: 2,
            border: `1px solid ${alpha(BRAND.blue, 0.14)}`,
            boxShadow: "0 24px 70px rgba(15,23,42,0.10)",
            background:
              "linear-gradient(135deg, #0f172a 0%, #1d4ed8 46%, #f97316 120%)",
            color: "#fff",
          }}
        >
          <CardContent sx={{ p: { xs: 2, md: 3.5 } }}>
            <Stack
              direction={{ xs: "column", md: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "stretch", md: "center" }}
              spacing={2}
            >
              <Box sx={{ minWidth: 0 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <MeetingRoomIcon />
                  <Typography
                    variant="overline"
                    sx={{ fontWeight: 900, letterSpacing: 1.2, opacity: 0.85 }}
                  >
                    MESYAT DIGITAL · {TT.dbConnected}
                  </Typography>
                </Stack>

                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 950,
                    letterSpacing: -0.8,
                    mt: 0.6,
                    fontSize: { xs: 26, md: 38 },
                  }}
                >
                  {TT.pageTitle}
                </Typography>

                <Typography
                  sx={{
                    mt: 1,
                    maxWidth: 820,
                    opacity: 0.88,
                    fontWeight: 650,
                    lineHeight: 1.55,
                    fontSize: { xs: 13.5, md: 15 },
                  }}
                >
                  {TT.pageSubtitle}
                </Typography>
              </Box>

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1}
                sx={{
                  "& .MuiButton-root": {
                    borderRadius: 3,
                    textTransform: "none",
                    fontWeight: 950,
                    minHeight: 46,
                  },
                }}
              >
                <ToggleButtonGroup
                  exclusive
                  value={lang}
                  onChange={(e, value) => {
                    if (!value) return;
                    setLang(value);
                    localStorage.setItem("panel_dili", value);
                  }}
                  size="small"
                  sx={{
                    bgcolor: "rgba(255,255,255,.14)",
                    borderRadius: 3,
                    p: 0.4,
                    "& .MuiToggleButton-root": {
                      color: "#fff",
                      border: 0,
                      borderRadius: "10px !important",
                      fontWeight: 950,
                      px: 1.4,
                    },
                    "& .Mui-selected": {
                      bgcolor: "#fff !important",
                      color: `${BRAND.blueDark} !important`,
                    },
                  }}
                >
                  <ToggleButton value="tr">TR</ToggleButton>
                  <ToggleButton value="en">EN</ToggleButton>
                  <ToggleButton value="de">DE</ToggleButton>
                </ToggleButtonGroup>

                <Button
                  variant="contained"
                  startIcon={<RefreshIcon />}
                  onClick={loadLiveData}
                  disabled={loading}
                  sx={{
                    bgcolor: "#fff",
                    color: BRAND.blueDark,
                    "&:hover": { bgcolor: "#f8fafc" },
                  }}
                >
                  {TT.refresh}
                </Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>

        {loading && (
          <LinearProgress
            sx={{
              mb: 2,
              height: 6,
              borderRadius: 99,
              bgcolor: alpha(BRAND.blue, 0.1),
              "& .MuiLinearProgress-bar": {
                background: `linear-gradient(90deg, ${BRAND.blue}, ${BRAND.orange})`,
              },
            }}
          />
        )}

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0,1fr))",
              lg: "repeat(4, minmax(0,1fr))",
            },
            gap: 1.5,
            mb: 2,
          }}
        >
          {statCards.map((card) => (
            <Card
              key={card.title}
              sx={{
                borderRadius: 4,
                border: `1px solid ${alpha(card.color, 0.14)}`,
                boxShadow: "0 14px 38px rgba(15,23,42,0.07)",
              }}
            >
              <CardContent sx={{ p: 2 }}>
                <Stack direction="row" alignItems="center" spacing={1.5}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 3,
                      bgcolor: card.bg,
                      color: card.color,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {card.icon}
                  </Box>

                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "text.secondary",
                        fontWeight: 850,
                      }}
                    >
                      {card.title}
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 950,
                        color: card.color,
                        lineHeight: 1.1,
                        wordBreak: "break-word",
                      }}
                    >
                      {card.value}
                    </Typography>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Box>

        <Card
          sx={{
            mb: 2,
            borderRadius: 4,
            border: `1px solid ${alpha(BRAND.blue, 0.12)}`,
            boxShadow: "0 14px 38px rgba(15,23,42,0.06)",
          }}
        >
          <CardContent sx={{ p: 1.2 }}>
            <ToggleButtonGroup
              exclusive
              value={activePanel}
              onChange={(e, value) => {
                if (value) setActivePanel(value);
              }}
              fullWidth
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
                gap: 1,
                "& .MuiToggleButtonGroup-grouped": {
                  border: "1px solid #e2e8f0 !important",
                  borderRadius: "16px !important",
                  mx: "0 !important",
                },
                "& .MuiToggleButton-root": {
                  minHeight: 48,
                  textTransform: "none",
                  fontWeight: 950,
                  color: BRAND.blueDark,
                },
                "& .Mui-selected": {
                  bgcolor: `${BRAND.softBlue} !important`,
                  color: `${BRAND.blue} !important`,
                  borderColor: `${alpha(BRAND.blue, 0.35)} !important`,
                },
              }}
            >
              <ToggleButton value="live">
                <EventSeatIcon sx={{ mr: 1 }} /> {TT.liveBoard}
              </ToggleButton>
              <ToggleButton value="reports">
                <AssessmentIcon sx={{ mr: 1 }} /> {TT.reports}
              </ToggleButton>
              <ToggleButton value="training">
                <SchoolIcon sx={{ mr: 1 }} /> {TT.training}
              </ToggleButton>
            </ToggleButtonGroup>
          </CardContent>
        </Card>

        {activePanel === "live" && renderLiveBoard()}
        {activePanel === "reports" && renderReports()}
        {activePanel === "training" && renderTraining()}
      </Box>

      <Dialog
        open={Boolean(selectedTable)}
        onClose={() => setSelectedTableId(null)}
        fullScreen={isMobile}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: { xs: 0, sm: 4 },
            overflow: "hidden",
          },
        }}
      >
        {selectedTable && selectedStats && (
          <>
            <DialogTitle
              sx={{
                p: 0,
                background:
                  "linear-gradient(135deg, #0f172a 0%, #2563eb 55%, #f97316 130%)",
                color: "#fff",
              }}
            >
              <Box sx={{ p: { xs: 2, md: 2.5 } }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  spacing={1}
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      variant="overline"
                      sx={{ fontWeight: 900, opacity: 0.82 }}
                    >
                      {selectedSalon?.name || selectedSalon?.salon_adi || TT.salon}
                    </Typography>

                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 950, lineHeight: 1.1 }}
                    >
                      {selectedTable.name || selectedTable.masa_adi}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ mt: 0.8, opacity: 0.82, fontWeight: 650 }}
                    >
                      {selectedTable.capacity || selectedTable.kapasite || 0} kişi ·{" "}
                      {TT.openBill}
                    </Typography>
                  </Box>

                  <IconButton
                    onClick={() => setSelectedTableId(null)}
                    sx={{
                      color: "#fff",
                      bgcolor: "rgba(255,255,255,.12)",
                      "&:hover": { bgcolor: "rgba(255,255,255,.22)" },
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Stack>
              </Box>
            </DialogTitle>

            <DialogContent
              sx={{
                p: { xs: 1.4, md: 2.5 },
                bgcolor: "#f8fafc",
              }}
            >
              <Stack spacing={1.5}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "repeat(3, minmax(0,1fr))",
                    },
                    gap: 1,
                  }}
                >
                  {[
                    [TT.total, selectedStats.total, BRAND.blue],
                    [TT.paid, selectedStats.paid, theme.palette.success.main],
                    [TT.remaining, selectedStats.remaining, BRAND.orange],
                  ].map(([label, value, color]) => (
                    <Card key={label} sx={{ borderRadius: 3 }}>
                      <CardContent sx={{ p: 1.4 }}>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ fontWeight: 800 }}
                        >
                          {label}
                        </Typography>

                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 950,
                            color,
                            wordBreak: "break-word",
                          }}
                        >
                          {moneyText(value, selectedStats.currency, lang)}
                        </Typography>
                      </CardContent>
                    </Card>
                  ))}
                </Box>

                <Card sx={{ borderRadius: 3 }}>
                  <CardContent sx={{ p: { xs: 1.4, md: 2 } }}>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={1}
                      sx={{
                        "& .MuiButton-root": {
                          borderRadius: 2.4,
                          textTransform: "none",
                          fontWeight: 950,
                          minHeight: 44,
                        },
                      }}
                    >
                      <Button
                        fullWidth
                        variant="contained"
                        startIcon={<PersonAddIcon />}
                        onClick={() => openAddGuest(selectedTable.id)}
                        sx={{
                          bgcolor: BRAND.orange,
                          "&:hover": { bgcolor: BRAND.orangeDark },
                        }}
                      >
                        {TT.addGuest}
                      </Button>




<Button
  fullWidth
  variant="outlined"
  startIcon={<EditIcon />}
  onClick={() =>
    openEditTable(selectedTable)
  }
>
  {TT.editTable}
</Button>

<Button
  fullWidth
  variant="outlined"
  startIcon={<SwapHorizIcon />}
  onClick={() =>
    openTableTransfer(
      selectedTable.id
    )
  }
  disabled={
    selectedStats.orders.length === 0 &&
    selectedStats.guests.length === 0 &&
    selectedStats.payments.length === 0
  }
  sx={{
    color: BRAND.purple,

    borderColor: alpha(
      BRAND.purple,
      0.35
    ),

    "&:hover": {
      borderColor: BRAND.purple,

      bgcolor: alpha(
        BRAND.purple,
        0.05
      ),
    },
  }}
>
  Masayı Taşı
</Button>

<Button
  fullWidth
  variant="outlined"
  startIcon={<PointOfSaleIcon />}
  onClick={() => {
    window.location.hash =
      "/kasa-tahsilat";
  }}
>
  {TT.cashPanel}
</Button>




                    </Stack>

                    <Divider sx={{ my: 1.5 }} />

                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={1}
                      sx={{
                        "& .MuiButton-root": {
                          borderRadius: 2.4,
                          textTransform: "none",
                          fontWeight: 900,
                          minHeight: 42,
                        },
                      }}
                    >
                      <Button
                        fullWidth
                        variant="outlined"
                        onClick={() => markTableStatus(selectedTable.id, "reserved")}
                      >
                        📌 {TT.markReserved}
                      </Button>

                   

                      <Button
                        fullWidth
                        variant="outlined"
                        color="error"
                        onClick={() => markTableStatus(selectedTable.id, "locked")}
                      >
                        {TT.markLocked}
                      </Button>

                      <Button
                        fullWidth
                        variant="outlined"
                        onClick={() => markTableStatus(selectedTable.id, "empty")}
                      >
                        {TT.markEmpty}
                      </Button>
                    </Stack>
                  </CardContent>
                </Card>

                <Card sx={{ borderRadius: 3 }}>
                  <CardContent sx={{ p: { xs: 1.4, md: 2 } }}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={1}
                      sx={{ mb: 1 }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 950 }}>
                        👥 {TT.guests}
                      </Typography>

                      <Chip
                        size="small"
                        label={selectedStats.guests.length}
                        sx={{ fontWeight: 950 }}
                      />
                    </Stack>

                    {selectedStats.guests.length === 0 ? (
                      <Alert severity="info" sx={{ borderRadius: 3 }}>
                        {TT.noGuests}
                      </Alert>
                    ) : (
                      <Stack spacing={1}>
                        {selectedStats.guests.map((guest) => (
                          <Box
                            key={guest.id}
                            sx={{
                              p: 1.2,
                              borderRadius: 3,
                              bgcolor: "#fff",
                              border: "1px solid #e2e8f0",
                              display: "grid",
                              gridTemplateColumns: "1fr auto",
                              gap: 1,
                              alignItems: "center",
                            }}
                          >
                            <Box sx={{ minWidth: 0 }}>
                              <Typography sx={{ fontWeight: 950 }}>
                                {guest.name || guest.kisi_adi}
                              </Typography>

                              {(guest.description || guest.kisi_tanimi) && (
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  sx={{ fontWeight: 750 }}
                                >
                                  {guest.description || guest.kisi_tanimi}
                                </Typography>
                              )}
                            </Box>

                            <Stack direction="row" spacing={0.5}>
                              <Tooltip title={TT.edit}>
                                <IconButton
                                  color="primary"
                                  onClick={() => openEditGuest(guest)}
                                >
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title={TT.delete}>
                                <IconButton
                                  color="error"
                                  onClick={() => deleteGuest(guest.id)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </Stack>
                          </Box>
                        ))}
                      </Stack>
                    )}
                  </CardContent>
                </Card>

                <Card sx={{ borderRadius: 3 }}>
                  <CardContent sx={{ p: { xs: 1.4, md: 2 } }}>
                    <Typography variant="h6" sx={{ fontWeight: 950, mb: 1 }}>
                      🍽️ {TT.orders}
                    </Typography>

                    {selectedStats.orders.length === 0 ? (
                      <Alert severity="info" sx={{ borderRadius: 3 }}>
                        {TT.noOrders}
                      </Alert>
                    ) : (
                      <Stack spacing={1}>
                        {selectedStats.orders.map((order) => (
                          <Box
                            key={order.id}
                            sx={{
                              p: 1.2,
                              borderRadius: 3,
                              bgcolor: "#fff",
                              border: "1px solid #e2e8f0",
                            }}
                          >
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              spacing={1}
                              sx={{ mb: 0.8 }}
                            >
                              <Typography sx={{ fontWeight: 950 }}>
                                #{order.id} · {order.musteri_adi || "Misafir"}
                              </Typography>

                              <Chip
                                size="small"
                                label={order.durum || "-"}
                                sx={{ fontWeight: 850 }}
                              />
                            </Stack>

                            <Stack spacing={0.6}>
                              {(order.items || []).map((item, index) => {
                                const qty = getItemQty(item);
                                const title = getItemTitle(item);
                                const lineTotal = getItemLineTotal(item);

                                return (
                                  <Box
                                    key={`${order.id}-${index}`}
                                    sx={{
                                      display: "grid",
                                      gridTemplateColumns: "1fr auto",
                                      gap: 1,
                                      fontSize: 13,
                                    }}
                                  >
                                    <Typography
                                      variant="body2"
                                      sx={{ fontWeight: 800, minWidth: 0 }}
                                    >
                                      {qty}x {title}
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      sx={{ fontWeight: 950 }}
                                    >
                                      {moneyText(
                                        lineTotal,
                                        item.currency || order.currency,
                                        lang
                                      )}
                                    </Typography>
                                  </Box>
                                );
                              })}
                            </Stack>

                            <Divider sx={{ my: 1 }} />

                            <Typography
                              sx={{
                                textAlign: "right",
                                fontWeight: 950,
                                color: BRAND.blue,
                              }}
                            >
                              {TT.total}:{" "}
                              {moneyText(
                                order.toplam_tutar,
                                order.currency,
                                lang
                              )}
                            </Typography>
                          </Box>
                        ))}
                      </Stack>
                    )}
                  </CardContent>
                </Card>

                <Card sx={{ borderRadius: 3 }}>
                  <CardContent sx={{ p: { xs: 1.4, md: 2 } }}>
                    <Typography variant="h6" sx={{ fontWeight: 950, mb: 1 }}>
                      💳 {TT.paymentRequests}
                    </Typography>

                    {selectedStats.payments.length === 0 ? (
                      <Alert severity="info" sx={{ borderRadius: 3 }}>
                        {TT.noPayments}
                      </Alert>
                    ) : (
                      <Stack spacing={1}>
                        {selectedStats.payments.map((req) => {
                          const isPending = req.status === "bekliyor";

                          return (
                            <Box
                              key={req.id}
                              sx={{
                                p: 1.2,
                                borderRadius: 3,
                                bgcolor: isPending ? BRAND.softOrange : "#fff",
                                border: `1px solid ${
                                  isPending ? "#fed7aa" : "#e2e8f0"
                                }`,
                              }}
                            >
                              <Stack
                                direction={{ xs: "column", sm: "row" }}
                                justifyContent="space-between"
                                spacing={1}
                              >
                                <Box sx={{ minWidth: 0 }}>
                                  <Stack
                                    direction="row"
                                    spacing={0.7}
                                    flexWrap="wrap"
                                    useFlexGap
                                  >
                                    <Chip
                                      size="small"
                                      label={req.musteri_adi || "Misafir"}
                                      sx={{ fontWeight: 850 }}
                                    />
                                    <Chip
                                      size="small"
                                      color={isPending ? "warning" : "success"}
                                      label={req.status || "-"}
                                      sx={{ fontWeight: 850 }}
                                    />
                                    <Chip
                                      size="small"
                                      label={req.payment_type || "-"}
                                      sx={{ fontWeight: 850 }}
                                    />
                                  </Stack>

                                  <Typography
                                    variant="h6"
                                    sx={{
                                      mt: 0.8,
                                      fontWeight: 950,
                                      color: isPending
                                        ? BRAND.orangeDark
                                        : theme.palette.success.main,
                                    }}
                                  >
                                    {moneyText(req.amount, req.currency, lang)}
                                  </Typography>

                                  {safeNumber(req.tip_amount) > 0 && (
                                    <Typography
                                      variant="caption"
                                      sx={{ fontWeight: 750 }}
                                    >
                                      Bahşiş:{" "}
                                      {moneyText(
                                        req.tip_amount,
                                        req.currency,
                                        lang
                                      )}
                                    </Typography>
                                  )}
                                </Box>

                                {isPending && (
                                  <Stack
                                    direction={{ xs: "column", sm: "row" }}
                                    spacing={0.8}
                                    sx={{
                                      minWidth: { sm: 330 },
                                      "& .MuiButton-root": {
                                        borderRadius: 2.2,
                                        textTransform: "none",
                                        fontWeight: 950,
                                      },
                                    }}
                                  >
                                    <Button
                                      fullWidth
                                      color="success"
                                      variant="contained"
                                      startIcon={<CheckCircleIcon />}
                                      onClick={() =>
                                        updatePaymentStatus(
                                          req.id,
                                          "odendi",
                                          "cash"
                                        )
                                      }
                                    >
                                      {TT.cashPaid}
                                    </Button>

                                    <Button
                                      fullWidth
                                      color="primary"
                                      variant="contained"
                                      onClick={() =>
                                        updatePaymentStatus(
                                          req.id,
                                          "odendi",
                                          "card"
                                        )
                                      }
                                    >
                                      {TT.cardPaid}
                                    </Button>

                                    <Button
                                      fullWidth
                                      color="error"
                                      variant="outlined"
                                      onClick={() =>
                                        updatePaymentStatus(
                                          req.id,
                                          "reddedildi"
                                        )
                                      }
                                    >
                                      {TT.reject}
                                    </Button>
                                  </Stack>
                                )}
                              </Stack>
                            </Box>
                          );
                        })}
                      </Stack>
                    )}
                  </CardContent>
                </Card>
              </Stack>
            </DialogContent>

            <DialogActions
              sx={{
                p: { xs: 1.4, md: 2 },
                bgcolor: "#fff",
                borderTop: "1px solid #e2e8f0",
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
                gap: 1,
                "& .MuiButton-root": {
                  borderRadius: 2.4,
                  textTransform: "none",
                  fontWeight: 950,
                  minHeight: 44,
                },
              }}
            >
              <Button
                variant="outlined"
                onClick={() => clearTable(selectedTable.id)}
              >
                {TT.clearTable}
              </Button>

              <Button
                color="error"
                variant="outlined"
                startIcon={<DeleteIcon />}
                onClick={() => deleteTable(selectedTable.id)}
              >
                {TT.delete}
              </Button>

              <Button
                variant="contained"
                onClick={() => setSelectedTableId(null)}
                sx={{
                  bgcolor: BRAND.blueDark,
                  "&:hover": { bgcolor: "#020617" },
                }}
              >
                {TT.close}
              </Button>
            </DialogActions>
          </>
        )}



      </Dialog>

      <Dialog
        open={transferDialog}
        onClose={() => {
          if (!transferLoading) {
            setTransferDialog(false);
          }
        }}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 4,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 950,
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
          >
            <SwapHorizIcon
              sx={{
                color: BRAND.purple,
              }}
            />

            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 950,
                }}
              >
                Masayı Taşı
              </Typography>

              <Typography
                variant="caption"
                color="text.secondary"
              >
                {transferSourceTable?.name ||
                  transferSourceTable?.masa_adi ||
                  ""}
              </Typography>
            </Box>
          </Stack>
        </DialogTitle>

        <DialogContent>
          <Alert
            severity="info"
            sx={{
              borderRadius: 3,
              mb: 2,
            }}
          >
            Açık siparişler, masadaki
            kişiler ve ödeme talepleri
            seçtiğiniz boş masaya birlikte
            taşınır. Kaynak masa işlem
            sonunda boşaltılır.
          </Alert>

          {transferCandidateTables.length ===
          0 ? (
            <Alert
              severity="warning"
              sx={{
                borderRadius: 3,
              }}
            >
              Taşımaya uygun boş masa
              bulunamadı.
            </Alert>
          ) : (
            <TextField
              select
              fullWidth
              label="Hedef boş masa"
              value={transferTargetTableId}
              onChange={(event) =>
                setTransferTargetTableId(
                  event.target.value
                )
              }
            >
              {transferCandidateTables.map(
                (table) => {
                  const salon =
                    salons.find(
                      (item) =>
                        String(item.id) ===
                        String(
                          table.salon_id
                        )
                    );

                  return (
                    <MenuItem
                      key={table.id}
                      value={table.id}
                    >
                      {salon?.name ||
                        salon?.salon_adi ||
                        "Salon"}{" "}
                      ·{" "}
                      {table.name ||
                        table.masa_adi}
                    </MenuItem>
                  );
                }
              )}
            </TextField>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            p: 2,
          }}
        >
          <Button
            onClick={() =>
              setTransferDialog(false)
            }
            disabled={transferLoading}
          >
            {TT.cancel}
          </Button>

          <Button
            variant="contained"
            startIcon={<SwapHorizIcon />}
            onClick={
              completeTableTransfer
            }
            disabled={
              transferLoading ||
              !transferTargetTableId ||
              transferCandidateTables.length ===
                0
            }
            sx={{
              bgcolor: BRAND.purple,

              "&:hover": {
                bgcolor: "#6d28d9",
              },

              borderRadius: 2.5,
              textTransform: "none",
              fontWeight: 950,
            }}
          >
            {transferLoading
              ? "Taşınıyor..."
              : "Taşımayı Tamamla"}
          </Button>
        </DialogActions>
      </Dialog>








<Dialog
  open={manualDialog}
  onClose={() => setManualDialog(false)}
  fullScreen={isMobile}
  maxWidth={false}
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: { xs: 0, sm: 4 },
      overflow: "hidden",
      width: { xs: "100%", sm: "96vw" },
      maxWidth: 1440,
      height: { xs: "100%", sm: "92vh" },
      maxHeight: { xs: "100%", sm: 920 },
      display: "flex",
      flexDirection: "column",
      bgcolor: "#f6f8fc",
      boxShadow: "0 28px 90px rgba(15,23,42,0.24)",
    },
  }}
>
  <DialogTitle
    sx={{
      px: { xs: 1.5, sm: 2.5 },
      py: 1.5,
      bgcolor: "#fff",
      borderBottom: "1px solid #e8edf5",
      flexShrink: 0,
    }}
  >
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: 2.5,
            display: "grid",
            placeItems: "center",
            color: "#fff",
            bgcolor: BRAND.blue,
            boxShadow: `0 10px 24px ${alpha(BRAND.blue, 0.24)}`,
          }}
        >
          <Inventory2Icon />
        </Box>

        <Box>
          <Typography
            variant="h6"
            sx={{ fontWeight: 900, lineHeight: 1.15 }}
          >
            Manuel Ürün Ekle
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: 700, mt: 0.25 }}
          >
            {selectedTable?.name || selectedTable?.masa_adi || ""}
          </Typography>
        </Box>
      </Stack>

      <IconButton
        onClick={() => setManualDialog(false)}
        sx={{
          bgcolor: "#f1f5f9",
          color: "#475569",
          "&:hover": { bgcolor: "#e2e8f0" },
        }}
      >
        <CloseIcon />
      </IconButton>
    </Stack>
  </DialogTitle>

  <DialogContent
    sx={{
      bgcolor: "#f6f8fc",
      p: { xs: 1.25, md: 2 },
      flex: 1,
      minHeight: 0,
      overflow: { xs: "auto", md: "hidden" },
    }}
  >
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "minmax(0,1.65fr) minmax(340px,.75fr)",
        },
        gap: 2,
        height: { md: "100%" },
        minHeight: 0,
      }}
    >
      <Card
        elevation={0}
        sx={{
          borderRadius: 4,
          border: "1px solid #e4eaf2",
          bgcolor: "#fff",
          height: { md: "100%" },
          minHeight: 0,
          overflowY: { xs: "visible", md: "auto" },
          scrollbarWidth: "thin",
          scrollbarColor: "#cbd5e1 transparent",

          "&::-webkit-scrollbar": {
            width: 7,
          },

          "&::-webkit-scrollbar-thumb": {
            bgcolor: "#cbd5e1",
            borderRadius: 99,
          },
        }}
      >
        <CardContent sx={{ p: { xs: 1.25, md: 1.75 } }}>
          <Box
            sx={{
              position: { md: "sticky" },
              top: 0,
              zIndex: 5,
              bgcolor: "rgba(255,255,255,0.96)",
              backdropFilter: "blur(10px)",
              pb: 1.25,
              mb: 1.25,
              borderBottom: "1px solid #edf1f6",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              spacing={1}
              sx={{ mb: 1.25 }}
            >
              <Stack direction="row" alignItems="center" spacing={0.8}>
                <RestaurantMenuIcon sx={{ color: BRAND.blue }} />

                <Typography variant="h6" sx={{ fontWeight: 900 }}>
                  Menü Ürünleri
                </Typography>
              </Stack>

              <Chip
                size="small"
                label={`${filteredMenuItems.length} ürün`}
                sx={{
                  fontWeight: 800,
                  bgcolor: BRAND.softBlue,
                  color: BRAND.blue,
                }}
              />
            </Stack>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "minmax(0,1fr) auto",
                },
                gap: 1,
                mb: 1.15,
              }}
            >
              <TextField
                fullWidth
                size="small"
                value={manualSearch}
                onChange={(event) =>
                  setManualSearch(event.target.value)
                }
                placeholder="Ürün ara: pizza, İskender, rakı..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#94a3b8" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2.5,
                    bgcolor: "#f8fafc",
                  },
                }}
              />

              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => {
                  const section = document.getElementById(
                    "manual-custom-item-section"
                  );

                  section?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });

                  window.setTimeout(
                    () => section?.querySelector("input")?.focus(),
                    350
                  );
                }}
                sx={{
                  minHeight: 40,
                  px: 2,
                  borderRadius: 2.5,
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  fontWeight: 850,
                  bgcolor: BRAND.orange,
                  boxShadow: "none",

                  "&:hover": {
                    bgcolor: BRAND.orangeDark,
                    boxShadow: "none",
                  },
                }}
              >
                Menüde Yok / Özel Ürün
              </Button>
            </Box>

            {menuLoading && (
              <LinearProgress
                sx={{ mb: 1.1, borderRadius: 99 }}
              />
            )}

            {menuCategories.length > 0 && (
              <Stack
                direction="row"
                spacing={0.75}
                sx={{
                  overflowX: "auto",
                  pb: 0.35,
                  scrollbarWidth: "thin",

                  "& .MuiChip-root": {
                    flexShrink: 0,
                  },

                  "&::-webkit-scrollbar": {
                    height: 4,
                  },

                  "&::-webkit-scrollbar-thumb": {
                    bgcolor: "#cbd5e1",
                    borderRadius: 99,
                  },
                }}
              >
                <Chip
                  clickable
                  size="small"
                  label="Tüm Menü"
                  color={
                    selectedMenuCategoryId === "all"
                      ? "primary"
                      : "default"
                  }
                  onClick={() => setSelectedMenuCategoryId("all")}
                  sx={{ fontWeight: 850, height: 32 }}
                />

                {menuCategories.map((category) => (
                  <Chip
                    key={category.id}
                    clickable
                    size="small"
                    label={`${category.title} (${category.items.length})`}
                    color={
                      String(selectedMenuCategoryId) ===
                      String(category.id)
                        ? "primary"
                        : "default"
                    }
                    onClick={() =>
                      setSelectedMenuCategoryId(category.id)
                    }
                    sx={{ fontWeight: 800, height: 32 }}
                  />
                ))}
              </Stack>
            )}
          </Box>

          {!menuLoading && filteredMenuItems.length === 0 ? (
            <Alert
              severity="info"
              sx={{ borderRadius: 3, mb: 2 }}
            >
              Menü Yönetimi’nde aktif ürün bulunamadı veya
              aramayla eşleşen ürün yok.
            </Alert>
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  lg: "repeat(2,minmax(0,1fr))",
                },
                gap: 1.15,
                mb: 2,
              }}
            >
              {filteredMenuItems.map((item) => (
                <Box
                  key={`menu-${item.id}`}
                  sx={{
                    p: 1.25,
                    borderRadius: 3,
                    bgcolor: "#fff",
                    border: "1px solid #e4eaf2",
                    minHeight: 120,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    transition:
                      "border-color .18s ease,box-shadow .18s ease,transform .18s ease",

                    "&:hover": {
                      borderColor: alpha(BRAND.blue, 0.34),
                      boxShadow:
                        "0 10px 24px rgba(15,23,42,0.08)",
                      transform: "translateY(-1px)",
                    },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="flex-start"
                    spacing={1}
                  >
                    <Box
                      sx={{
                        width: 38,
                        height: 38,
                        borderRadius: 2,
                        display: "grid",
                        placeItems: "center",
                        flexShrink: 0,
                        bgcolor: BRAND.softBlue,
                        color: BRAND.blue,
                        fontWeight: 900,
                      }}
                    >
                      {String(item.title || "?")
                        .trim()
                        .charAt(0)
                        .toLocaleUpperCase("tr-TR")}
                    </Box>

                    <Box sx={{ minWidth: 0 }}>
                      <Typography
                        title={item.title}
                        noWrap
                        sx={{
                          fontWeight: 850,
                          fontSize: 15,
                          lineHeight: 1.25,
                        }}
                      >
                        {item.title}
                      </Typography>

                      <Chip
                        size="small"
                        label={item.category_title || "Menü"}
                        sx={{
                          mt: 0.55,
                          height: 22,
                          fontSize: 11,
                          fontWeight: 750,
                          bgcolor: "#f1f5f9",
                        }}
                      />
                    </Box>
                  </Stack>

                  {item.price_options.length === 0 && (
                    <Button
                      fullWidth
                      size="small"
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => addMenuToBasket(item)}
                      sx={{
                        mt: 1.2,
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 850,
                        bgcolor: BRAND.orange,
                        boxShadow: "none",

                        "&:hover": {
                          bgcolor: BRAND.orangeDark,
                          boxShadow: "none",
                        },
                      }}
                    >
                      {moneyText(
                        item.price,
                        item.currency,
                        lang
                      )}
                    </Button>
                  )}

                  {item.price_options.length > 0 && (
                    <Stack
                      direction="row"
                      spacing={0.7}
                      useFlexGap
                      flexWrap="wrap"
                      sx={{ mt: 1.2 }}
                    >
                      {item.price_options.map((option) => (
                        <Button
                          key={`${item.id}-${option.id}`}
                          size="small"
                          variant="outlined"
                          startIcon={<AddIcon />}
                          onClick={() =>
                            addMenuToBasket(item, option)
                          }
                          sx={{
                            flex: "1 1 auto",
                            minWidth: 0,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 800,
                            fontSize: 12,
                          }}
                        >
                          {option.label} ·{" "}
                          {moneyText(
                            option.price,
                            option.currency,
                            lang
                          )}
                        </Button>
                      ))}
                    </Stack>
                  )}
                </Box>
              ))}
            </Box>
          )}

          <Divider sx={{ mb: 1.5 }} />

          <Typography
            variant="h6"
            sx={{ fontWeight: 900, mb: 1 }}
          >
            Stok / Özel Ürünler
          </Typography>

          <Box
            id="manual-custom-item-section"
            sx={{
              mb: 2,
              scrollMarginTop: 16,
              p: { xs: 1.2, md: 1.5 },
              borderRadius: 3.5,
              background: `linear-gradient(135deg,${BRAND.softOrange} 0%,#fff 100%)`,
              border: `1px solid ${alpha(
                BRAND.orange,
                0.24
              )}`,
              boxShadow:
                "0 8px 24px rgba(249,115,22,0.08)",
            }}
          >
            <Typography
              sx={{
                fontWeight: 850,
                color: BRAND.orangeDark,
                mb: 0.4,
              }}
            >
              Stokta Olmayan Özel Ürün
            </Typography>

            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "text.secondary",
                fontWeight: 750,
                mb: 1.2,
              }}
            >
              Örnek: Leblebi, özel tabak veya dışarıdan alınan
              ürün. Stoktan düşmez; masanın hesabına eklenir.
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "minmax(0,1.6fr) minmax(110px,.8fr)",
                  md: "minmax(0,1.5fr) minmax(110px,.7fr) minmax(90px,.55fr)",
                },
                gap: 1,
              }}
            >
              <TextField
                fullWidth
                size="small"
                label="Özel ürün adı"
                placeholder="Örn: Leblebi"
                value={customItemForm.title}
                onChange={(event) =>
                  setCustomItemForm((previous) => ({
                    ...previous,
                    title: event.target.value,
                  }))
                }
              />

              <TextField
                fullWidth
                size="small"
                type="number"
                label="Birim fiyat"
                inputProps={{ min: 0, step: "0.01" }}
                value={customItemForm.price}
                onChange={(event) =>
                  setCustomItemForm((previous) => ({
                    ...previous,
                    price: event.target.value,
                  }))
                }
              />

              <TextField
                fullWidth
                size="small"
                type="number"
                label="Adet"
                inputProps={{ min: 1, step: 1 }}
                value={customItemForm.quantity}
                onChange={(event) =>
                  setCustomItemForm((previous) => ({
                    ...previous,
                    quantity: event.target.value,
                  }))
                }
              />

              <TextField
                select
                fullWidth
                size="small"
                label="Para birimi"
                value={customItemForm.currency}
                onChange={(event) =>
                  setCustomItemForm((previous) => ({
                    ...previous,
                    currency: event.target.value,
                  }))
                }
              >
                {["TRY", "EUR", "USD", "CHF"].map(
                  (currency) => (
                    <MenuItem
                      key={currency}
                      value={currency}
                    >
                      {currency}
                    </MenuItem>
                  )
                )}
              </TextField>

              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={addCustomItemToBasket}
                sx={{
                  minHeight: 40,
                  borderRadius: 2.5,
                  textTransform: "none",
                  fontWeight: 850,
                  bgcolor: BRAND.orange,
                  gridColumn: {
                    xs: "1 / -1",
                    sm: "auto",
                  },

                  "&:hover": {
                    bgcolor: BRAND.orangeDark,
                  },
                }}
              >
                Özel Ürünü Ekle
              </Button>
            </Box>
          </Box>

          <Divider sx={{ mb: 1.5 }} />

          <Typography
            sx={{
              fontWeight: 900,
              color: BRAND.blueDark,
              mb: 1,
            }}
          >
            Stok Ürünleri
          </Typography>

          {filteredStockItems.length === 0 ? (
            <Alert severity="info" sx={{ borderRadius: 3 }}>
              Stok ürünü bulunamadı.
            </Alert>
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  lg: "repeat(2,minmax(0,1fr))",
                },
                gap: 1,
              }}
            >
              {filteredStockItems.map((item) => (
                <Box
                  key={item.id}
                  sx={{
                    p: 1.1,
                    borderRadius: 2.5,
                    bgcolor: "#fff",
                    border: "1px solid #e4eaf2",
                    display: "grid",
                    gridTemplateColumns: "1fr auto",
                    gap: 1,
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontWeight: 850,
                        fontSize: 14,
                      }}
                    >
                      {item.title || item.urun_adi}
                    </Typography>

                    <Stack
                      direction="row"
                      spacing={0.7}
                      flexWrap="wrap"
                      useFlexGap
                    >
                      <Chip
                        size="small"
                        label={`Stok: ${item.stock}`}
                        color={
                          Number(item.stock || 0) <= 0
                            ? "error"
                            : "default"
                        }
                        sx={{ fontWeight: 800 }}
                      />

                      <Chip
                        size="small"
                        label={moneyText(
                          item.price,
                          item.currency,
                          lang
                        )}
                        sx={{ fontWeight: 800 }}
                      />
                    </Stack>
                  </Box>

                  <Button
                    size="small"
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => addStockToBasket(item)}
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 850,
                      bgcolor: BRAND.orange,
                      boxShadow: "none",

                      "&:hover": {
                        bgcolor: BRAND.orangeDark,
                        boxShadow: "none",
                      },
                    }}
                  >
                    Ekle
                  </Button>
                </Box>
              ))}
            </Box>
          )}
        </CardContent>
      </Card>

      <Card
        elevation={0}
        sx={{
          borderRadius: 4,
          border: "1px solid #e4eaf2",
          bgcolor: "#fff",
          height: { md: "100%" },
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <CardContent
          sx={{
            p: { xs: 1.25, md: 1.75 },
            height: { md: "100%" },
            minHeight: 0,
            display: "flex",
            flexDirection: "column",

            "&:last-child": {
              pb: { xs: 1.25, md: 1.75 },
            },
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
            sx={{ mb: 1.25 }}
          >
            <Typography variant="h6" sx={{ fontWeight: 900 }}>
              Masa Sepeti
            </Typography>

            <Chip
              size="small"
              label={`${manualBasket.length} kalem`}
              sx={{
                fontWeight: 800,
                bgcolor: BRAND.softBlue,
                color: BRAND.blue,
              }}
            />
          </Stack>

          <Box
            sx={{
              flex: { md: 1 },
              minHeight: 0,
              overflowY: { md: "auto" },
              pr: { md: 0.5 },

              "&::-webkit-scrollbar": {
                width: 6,
              },

              "&::-webkit-scrollbar-thumb": {
                bgcolor: "#cbd5e1",
                borderRadius: 999,
              },
            }}
          >
            {manualBasket.length === 0 ? (
              <Alert
                severity="info"
                sx={{
                  borderRadius: 3,
                  bgcolor: "#f0f8ff",
                }}
              >
                Sepet boş. Soldan bir ürün seçin.
              </Alert>
            ) : (
              <Stack spacing={0.85}>
                {manualBasket.map((item) => (
                  <Box
                    key={getBasketItemKey(item)}
                    sx={{
                      p: 1.05,
                      borderRadius: 2.5,
                      bgcolor: "#fff",
                      border: "1px solid #e4eaf2",
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      spacing={1}
                    >
                      <Typography
                        sx={{
                          minWidth: 0,
                          fontWeight: 850,
                          fontSize: 14,
                          lineHeight: 1.3,
                        }}
                      >
                        {item.display_title || item.title}
                      </Typography>

                      <IconButton
                        size="small"
                        color="error"
                        onClick={() =>
                          removeBasketItem(
                            getBasketItemKey(item)
                          )
                        }
                      >
                        <RemoveCircleIcon fontSize="small" />
                      </IconButton>
                    </Stack>

                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <TextField
                        label="Adet"
                        size="small"
                        type="number"
                        value={item.quantity}
                        inputProps={{ min: 1, step: 1 }}
                        onChange={(event) =>
                          updateBasketQty(
                            getBasketItemKey(item),
                            event.target.value
                          )
                        }
                        sx={{ maxWidth: 100 }}
                      />

                      <Typography
                        sx={{
                          fontWeight: 900,
                          color: BRAND.blueDark,
                          textAlign: "right",
                        }}
                      >
                        {moneyText(
                          Number(item.price || 0) *
                            Number(item.quantity || 1),
                          item.currency,
                          lang
                        )}
                      </Typography>
                    </Stack>
                  </Box>
                ))}
              </Stack>
            )}
          </Box>

          <Divider sx={{ my: 1.25 }} />

          <TextField
            fullWidth
            multiline
            minRows={2}
            maxRows={3}
            size="small"
            label="Sipariş notu"
            value={manualNote}
            onChange={(event) =>
              setManualNote(event.target.value)
            }
            sx={{ mb: 1.25 }}
          />

          <Box
            sx={{
              p: 1.4,
              borderRadius: 3,
              background: `linear-gradient(135deg,${BRAND.softBlue} 0%,#fff 100%)`,
              border: `1px solid ${alpha(BRAND.blue, 0.16)}`,
            }}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontWeight: 800 }}
            >
              Toplam
            </Typography>

            <Typography
              variant="h5"
              sx={{
                fontWeight: 900,
                color: BRAND.blue,
              }}
            >
              {moneyText(
                manualBasketTotal,
                manualBasket[0]?.currency || "TRY",
                lang
              )}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  </DialogContent>

  <DialogActions
    sx={{
      px: { xs: 1.5, sm: 2.5 },
      py: 1.4,
      bgcolor: "#fff",
      borderTop: "1px solid #e4eaf2",
      flexShrink: 0,
      gap: 1,
    }}
  >
    <Button
      onClick={() => setManualDialog(false)}
      sx={{
        borderRadius: 2.5,
        textTransform: "none",
        fontWeight: 800,
      }}
    >
      {TT.cancel}
    </Button>

    <Button
      variant="contained"
      startIcon={<DoneAllIcon />}
      disabled={manualBasket.length === 0}
      onClick={completeManualOrder}
      sx={{
        bgcolor: BRAND.blueDark,
        minWidth: 160,
        minHeight: 44,
        borderRadius: 2.5,
        textTransform: "none",
        fontWeight: 850,
        boxShadow: "none",

        "&:hover": {
          bgcolor: "#020617",
          boxShadow: "none",
        },
      }}
    >
      Masaya İşle
    </Button>
  </DialogActions>
</Dialog>

<Dialog
  open={salonDialog}
        onClose={() => setSalonDialog(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{ sx: { borderRadius: 4 } }}
      >
        <DialogTitle sx={{ fontWeight: 950 }}>
          {editingSalonId ? TT.editSalon : TT.addSalon}
        </DialogTitle>

        <DialogContent>
          <Stack spacing={1.5} sx={{ mt: 1 }}>
            <TextField
              autoFocus
              fullWidth
              label={TT.salonName}
              value={salonForm.name}
              onChange={(e) =>
                setSalonForm((p) => ({ ...p, name: e.target.value }))
              }
            />

            <TextField
              fullWidth
              multiline
              minRows={2}
              label={TT.salonDesc}
              value={salonForm.description}
              onChange={(e) =>
                setSalonForm((p) => ({ ...p, description: e.target.value }))
              }
            />

            <TextField
              select
              fullWidth
              label="Renk"
              value={salonForm.color}
              onChange={(e) =>
                setSalonForm((p) => ({ ...p, color: e.target.value }))
              }
            >
              <MenuItem value={BRAND.blue}>Mavi</MenuItem>
              <MenuItem value={BRAND.orange}>Turuncu</MenuItem>
              <MenuItem value={BRAND.green}>Yeşil</MenuItem>
              <MenuItem value={BRAND.purple}>Mor</MenuItem>
            </TextField>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setSalonDialog(false)}>{TT.cancel}</Button>
          <Button variant="contained" onClick={saveSalon}>
            {editingSalonId ? TT.update : TT.save}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={tableDialog}
        onClose={() => setTableDialog(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: 4 } }}
      >
        <DialogTitle sx={{ fontWeight: 950 }}>
          {editingTableId ? TT.editTable : TT.addTable}
        </DialogTitle>

        <DialogContent>
          <Stack spacing={1.5} sx={{ mt: 1 }}>
            <TextField
              select
              fullWidth
              label={TT.salon}
              value={tableForm.salon_id}
              onChange={(e) =>
                setTableForm((p) => ({ ...p, salon_id: e.target.value }))
              }
            >
              {salons.map((salon) => (
                <MenuItem key={salon.id} value={salon.id}>
                  {salon.name || salon.salon_adi}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              fullWidth
              label={TT.tableName}
              value={tableForm.name}
              onChange={(e) =>
                setTableForm((p) => ({
                  ...p,
                  name: e.target.value,
                  masa_no: p.masa_no || e.target.value,
                }))
              }
              placeholder="Masa 1"
            />

            <TextField
              fullWidth
              label={TT.tableNo}
              value={tableForm.masa_no}
              onChange={(e) =>
                setTableForm((p) => ({ ...p, masa_no: e.target.value }))
              }
              placeholder="Masa 1"
            />

            <TextField
              fullWidth
              type="number"
              label={TT.tableCapacity}
              value={tableForm.capacity}
              onChange={(e) =>
                setTableForm((p) => ({ ...p, capacity: e.target.value }))
              }
            />

            <TextField
              fullWidth
              multiline
              minRows={2}
              label={TT.tableNote}
              value={tableForm.note}
              onChange={(e) =>
                setTableForm((p) => ({ ...p, note: e.target.value }))
              }
            />
          </Stack>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setTableDialog(false)}>{TT.cancel}</Button>
          <Button variant="contained" onClick={saveTable}>
            {editingTableId ? TT.update : TT.save}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={guestDialog}
        onClose={() => setGuestDialog(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: 4 } }}
      >
        <DialogTitle sx={{ fontWeight: 950 }}>
          {editingGuestId ? TT.editGuest : TT.addGuest}
        </DialogTitle>

        <DialogContent>
          <Stack spacing={1.5} sx={{ mt: 1 }}>
            <TextField
              autoFocus
              fullWidth
              label={TT.guestName}
              value={guestForm.name}
              placeholder={TT.guestPlaceholder}
              onChange={(e) =>
                setGuestForm((p) => ({ ...p, name: e.target.value }))
              }
            />

            <TextField
              fullWidth
              multiline
              minRows={2}
              label={TT.guestDesc}
              value={guestForm.description}
              placeholder={TT.guestDescPlaceholder}
              onChange={(e) =>
                setGuestForm((p) => ({ ...p, description: e.target.value }))
              }
            />

            <Box>
              <Typography
                variant="caption"
                sx={{ fontWeight: 950, color: "text.secondary" }}
              >
                {TT.quickDesc}
              </Typography>

              <Stack
                direction="row"
                spacing={0.7}
                flexWrap="wrap"
                useFlexGap
                sx={{ mt: 0.8 }}
              >
                {(DESC_TEMPLATES[lang] || DESC_TEMPLATES.tr).map((item) => (
                  <Chip
                    key={item}
                    clickable
                    label={item}
                    onClick={() =>
                      setGuestForm((p) => ({
                        ...p,
                        description: p.description
                          ? `${p.description}, ${item}`
                          : item,
                      }))
                    }
                    sx={{ fontWeight: 800 }}
                  />
                ))}
              </Stack>
            </Box>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setGuestDialog(false)}>{TT.cancel}</Button>
          <Button variant="contained" onClick={saveGuest}>
            {editingGuestId ? TT.update : TT.save}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snack.open}
        autoHideDuration={3200}
        onClose={() => setSnack((p) => ({ ...p, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snack.severity}
          onClose={() => setSnack((p) => ({ ...p, open: false }))}
          sx={{
            borderRadius: 3,
            fontWeight: 850,
            boxShadow: "0 18px 40px rgba(15,23,42,0.18)",
          }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
     </Box>
  );
}